function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME MODULE - QUEUE

 Game logic happens through the queue (technically more of a stack). When the game is created 
 (in Arcade, Redsquare, or wherever) or when loading the game page, the game engine calls 
 INITIALIZE GAME QUEUE to begin execution of the queue. Each player's queue *should* be the same.
 Queue commands are popped off the end, executed, and depending on their return value, execution 
 of the queue either pauses or continues (1 to continue, 0 to stop). This file defines several
 core queue commands within INITIALIZE QUEUE COMMANDS, but every game will also define its
 own necessary commands. All games must include the READY command, which is a signal that the
 game is initialized and we can step into the game page. Other useful commands involve the creation
 of a deck of cards and its manipulation in a way that is cryptographically secure. The deck is 
 shuffled in a way that neither player can "look ahead" at the cards without soliciting keys from 
 the other player(s). 

 Generally speaking, when the game requires user input, the command will return 0, stopping queue 
 execution. When the player has made their selection, they send a move over the network.
 The receipt of that move (which can consist of multiple ordered commands) is appended to the end
 of the queue, and execution is resumed. Note: most queue commands should remove themselves
 from the queue to prevent endless looping (unless that is intended). See GAMETEMPLATE-MOVES
 and GAMETEMPLATE-NETWORK for more information on submitting game moves and how game moves 
 received over the network are processed.

**********************************************************************************/
var saito = require('./../../saito/saito');
var Transaction = require('./../../saito/transaction')["default"];
var GameQueue = /*#__PURE__*/function () {
  function GameQueue() {
    _classCallCheck(this, GameQueue);
  }
  return _createClass(GameQueue, [{
    key: "handleGameLoop",
    value:
    //
    // Your game should implement this and add if-then logic to process your
    // self-defined game commands
    //
    function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, 0);
          }
        }, _callee);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }() //
    // this function prepares the game for any moves that are receives, including
    // preparing the UI. if it is NOT run then the queue is not executed and we should
    // not process new moves.
    //
  }, {
    key: "initializeGameQueue",
    value: function () {
      var _initializeGameQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(game_id) {
        var _this$game$options;
        var _this$game$options2, i;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              //
              // sanity load (multiplayer)
              //
              if (!this.game || this.game.id !== game_id) {
                //console.debug('GT [initializeGameQueue]: Loading Game');
                this.loadGame(game_id);
              }

              //
              // quit if already initialized, or not first time initialized
              //
              if (!(this.game.initialize_game_run == 1 && this.initialize_game_run == 1)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, 0);
            case 1:
              this.game.initialize_game_run = 1;
              this.initialize_game_run = 1;
            case 2:
              //Log the game state before we start doing anything...
              //console.debug('GT [initializeGameQueue]:', JSON.parse(JSON.stringify(this.game)));

              if (this.game.status != '') {
                this.hud.back_button = false;
                this.updateStatus(this.game.status);
              }

              //
              // if game is over, don't run queue
              //
              if (!(this.game.over == 1)) {
                _context2.n = 3;
                break;
              }
              this.gameOverUserInterface();
              return _context2.a(2, 0);
            case 3:
              this.initializeDice(); // Make sure we have dice before initializing the game

              // crypto support
              if ((_this$game$options = this.game.options) !== null && _this$game$options !== void 0 && _this$game$options.crypto && !this.game.crypto) {
                if (_typeof(this.game.options.stake) == 'object') {
                  this.game.stake = this.game.options.stake;
                } else {
                  if (parseFloat(this.game.options.stake)) {
                    this.game.stake = parseFloat(this.game.options.stake);
                  } else {
                    this.game.stake = 0;
                  }
                }
                this.game.crypto = this.game.options.crypto;
              }
              this.initializeGame(game_id);

              //
              // True initialization!!
              //
              if (this.game.step.game < 2) {
                // If the game is available for betting...
                if (this.game.crypto || this.can_bet || this.game.players.length > 1 && !((_this$game$options2 = this.game.options) !== null && _this$game$options2 !== void 0 && _this$game$options2.async_dealing)) {
                  //
                  // Add some commands to have players share what is available
                  //
                  if (!this.game.cryptos) {
                    //
                    // players one-by-one inform others of cryptos
                    //
                    for (i = 0; i < this.game.players.length; i++) {
                      this.game.queue.push('REQUEST_AVAILABLE_CRYPTOS\t' + (i + 1));
                    }
                    this.game.cryptos = {};
                  }
                }
                this.saveGame(this.game.id);
              }

              //
              // Start running the queue, or wait for relay to resend pending TXs
              //
              if (!(this.pending.length > 0 && this.browser_active)) {
                _context2.n = 4;
                break;
              }
              console.info("GT [initializeGameQueue]: don't start queue because have pending txs to resend");
              this.gaming_active = 1;
              //The pending transactions are processed elsewhere...
              _context2.n = 5;
              break;
            case 4:
              if (this.game.player == 0) {
                console.info('GT [initializeGameQueue]: Observer.... set active while loading...');
                this.gaming_active = 1;
              }
              _context2.n = 5;
              return this.startQueue();
            case 5:
              return _context2.a(2, 1);
          }
        }, _callee2, this);
      }));
      function initializeGameQueue(_x) {
        return _initializeGameQueue.apply(this, arguments);
      }
      return initializeGameQueue;
    }()
    /**
     *  Game moves are processed through a queue.
     */
  }, {
    key: "startQueue",
    value: function () {
      var _startQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var noqueue, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              console.info("GT [startQueue] halted: (".concat(this.halted, ") , gaming_active (").concat(this.gaming_active, ")"));
              console.debug('GT [startQueue] QUEUE: (' + this.game.step.game + ') ' + JSON.parse(JSON.stringify(this.game.queue)));
              console.debug('GT [startQueue] CONFIRMS_NEEDED: ' + JSON.stringify(this.game.confirms_needed));
              if (!(this.game.over == 1)) {
                _context3.n = 1;
                break;
              }
              console.trace('GT: Starting queue from game over state???');
              return _context3.a(2);
            case 1:
              //
              // skip if no-queue provided
              //
              noqueue = this.app.browser.returnURLParameter('noqueue');
              if (!noqueue) {
                _context3.n = 2;
                break;
              }
              alert('Skipping Queue: ' + JSON.stringify(this.game.queue));
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return this.runQueue();
            case 3:
              _t = _context3.v;
              if (!(_t == 0)) {
                _context3.n = 4;
                break;
              }
              _context3.n = 4;
              return this.processFutureMoves();
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function startQueue() {
        return _startQueue.apply(this, arguments);
      }
      return startQueue;
    }()
    /**
     * We use a flag halted to signal to the game engine that game execution
     * is paused pending user input. The ACKNOWLEDGE command and game animations
     * will often explicitly stop game queue execution.
     *
     * RESTART QUEUE is a function of convenience to toggle the flag back to 0 and
     * start executing queue commands again.
     */
  }, {
    key: "restartQueue",
    value: function () {
      var _restartQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this$deferred_game_e;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(this.gaming_active && !this.halted)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.halted = 0;

              //
              // process any stopgame / gameover that arrived while we were halted --
              // these may end the game, in which case there is no queue to restart
              //
              if (!((_this$deferred_game_e = this.deferred_game_end) !== null && _this$deferred_game_e !== void 0 && _this$deferred_game_e.length)) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return this.processDeferredGameEndTransactions();
            case 2:
              if (!(this.game.over == 1)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              this.saveGame(this.game.id);
              _context4.n = 4;
              return this.startQueue();
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function restartQueue() {
        return _restartQueue.apply(this, arguments);
      }
      return restartQueue;
    }()
    /**
     * This function searches the queue commands defined in INITIALIZE QUEUE COMMANDS
     * and HANDLE GAME LOOP (per module) to process the game command. Execution of the queue
     * continues until an encountered command returns 0 to temporarily stop execution of the game.
     */
  }, {
    key: "runQueue",
    value: function () {
      var _runQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var game_self, cont, loops_through_queue, queue_length, last_instruction, gqe, gmv, i, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              game_self = this;
              cont = 1;
              loops_through_queue = 0;
              queue_length = 0;
              last_instruction = ''; // I want to experiment with moving this to game-defined commands
              // So the UI can "pause" the screen but allow game engine commands to execute in the background
              // i.e. it only halts the game for UI updates
              if (!(this.halted === 1)) {
                _context5.n = 1;
                break;
              }
              this.gaming_active = 0;
              return _context5.a(2, -1);
            case 1:
              console.log('QUEUE IN GAME ENGINE: ' + JSON.stringify(game_self.game.queue));

              //
              // this indicates we are processing our queue
              //
              this.gaming_active = 1; // prevents future moves from getting added to the queue while it is processing
              //
              //stash a copy of state before doing anything
              //
              this.game_state_pre_move = JSON.parse(JSON.stringify(game_self.game));

            //
            // loop through the QUEUE (game stack)
            //
            case 2:
              if (!(game_self.game.queue.length > 0 && cont == 1)) {
                _context5.n = 10;
                break;
              }
              if (!(loops_through_queue >= 100 && queue_length == game_self.game.queue.length && last_instruction === game_self.game.queue[queue_length - 1])) {
                _context5.n = 3;
                break;
              }
              console.warn('GT [runQueue]: ENDLESS QUEUE LOOPING');
              return _context5.a(2, -1);
            case 3:
              gqe = game_self.game.queue.length - 1;
              console.info("GT [runQueue] -- MOVE (".concat(game_self.game.step.game, "): "), game_self.game.queue[gqe]);
              gmv = game_self.game.queue[gqe].split('\t');
              loops_through_queue++;
              queue_length = game_self.game.queue.length;
              last_instruction = game_self.game.queue[gqe];

              //
              //  Update the clock each time we process something automatically (so shuffling doesn't count against us)
              //
              if (this.browser_active) {
                this.game.time.last_received = new Date().getTime();
              }

              //
              // Check each of our game engine commands if anything triggers on gmv[0]
              //
              i = 0;
            case 4:
              if (!(i < game_self.commands.length)) {
                _context5.n = 7;
                break;
              }
              _context5.n = 5;
              return game_self.commands[i](game_self, gmv);
            case 5:
              _t2 = _context5.v;
              if (!(_t2 === 0)) {
                _context5.n = 6;
                break;
              }
              return _context5.a(2, 0);
            case 6:
              i++;
              _context5.n = 4;
              break;
            case 7:
              if (!(queue_length == game_self.game.queue.length && cont == 1 && last_instruction === game_self.game.queue[queue_length - 1])) {
                _context5.n = 9;
                break;
              }
              _context5.n = 8;
              return this.handleGameLoop();
            case 8:
              cont = _context5.v;
              if (cont == 0 && game_self.game.terminating && game_self.game.over == 0) {
                cont = 1;
              }
            case 9:
              _context5.n = 2;
              break;
            case 10:
              if (!cont) {
                _context5.n = 11;
                break;
              }
              _context5.n = 11;
              return this.handleGameLoop();
            case 11:
              return _context5.a(2, 0);
          }
        }, _callee5, this);
      }));
      function runQueue() {
        return _runQueue.apply(this, arguments);
      }
      return runQueue;
    }()
    /**
     *  This enormous function creates an array of functions that define the core functionality
     *  of the game engine.
     *
     */
  }, {
    key: "initializeQueueCommands",
    value: function initializeQueueCommands() {
      var _this = this;
      if (this.queue_commands_initialized == 1) {
        return;
      }
      this.queue_commands_initialized = 1;
      this.commands = [];
      this.commands.push(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(game_self, gmv) {
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                if (gmv[0] === 'SETVAR') {
                  if (gmv[1] === 'game') {
                    if (gmv[2]) {
                      gmv[1] = gmv[2];
                    }
                    if (gmv[3]) {
                      gmv[2] = gmv[3];
                    }
                    if (gmv[4]) {
                      gmv[3] = gmv[4];
                    }
                    if (gmv[5]) {
                      gmv[4] = gmv[5];
                      gmv[5] = null;
                    }
                  }
                  if (gmv[1]) {
                    if (gmv[3]) {
                      if (gmv[4]) {
                        if (gmv[5]) {
                          if (!game_self.game[gmv[1]][gmv[2]][gmv[3]][gmv[4]]) {
                            game_self.game[gmv[1]][gmv[2]][gmv[3]][gmv[4]] = {};
                          }
                          if (parseInt(gmv[5]) > 0) {
                            gmv[5] = parseInt(gmv[5]);
                          }
                          game_self.game[gmv[1]][gmv[2]][gmv[3]][gmv[4]] = gmv[5];
                        } else {
                          if (!game_self.game[gmv[1]][gmv[2]][gmv[3]]) {
                            game_self.game[gmv[1]][gmv[2]][gmv[3]] = {};
                          }
                          if (parseInt(gmv[4]) > 0) {
                            gmv[4] = parseInt(gmv[4]);
                          }
                          game_self.game[gmv[1]][gmv[2]][gmv[3]] = gmv[4];
                        }
                      } else {
                        if (!game_self.game[gmv[1]][gmv[2]]) {
                          game_self.game[gmv[1]][gmv[2]] = {};
                        }
                        if (parseInt(gmv[3]) > 0) {
                          gmv[3] = parseInt(gmv[3]);
                        }
                        game_self.game[gmv[1]][gmv[2]] = gmv[3];
                      }
                    } else {
                      if (gmv[2]) {
                        if (parseInt(gmv[2]) > 0) {
                          gmv[3] = parseInt(gmv[2]);
                        }
                        game_self.game[gmv[1]] = gmv[2];
                      }
                    }
                  }
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context6.a(2, 1);
            }
          }, _callee6);
        }));
        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(game_self, gmv) {
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                if (gmv[0] === 'SALERT' || gmv[0] === 'salert') {
                  if (game_self.app.BROWSER == 1) {
                    try {
                      salert(gmv[1]);
                    } catch (err) {}
                  }
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context7.a(2, 1);
            }
          }, _callee7);
        }));
        return function (_x4, _x5) {
          return _ref2.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(game_self, gmv) {
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                if (gmv[0] === 'NOTIFY' || gmv[0] === 'notify') {
                  game_self.updateLog(gmv[1]);
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context8.a(2, 1);
            }
          }, _callee8);
        }));
        return function (_x6, _x7) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(game_self, gmv) {
          var players_to_go, i, _i;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                if (gmv[0] === 'STATUS' || gmv[0] === 'status') {
                  if (!gmv[2]) {
                    gmv[2] = 'all';
                  }
                  players_to_go = [];
                  if (gmv[2] === 'all') {
                    for (i = 0; i < game_self.game.players.length; i++) {
                      players_to_go.push(i + 1);
                    }
                  } else {
                    try {
                      if (gmv[2].isArray()) {
                        players_to_go = gmv[2];
                      } else {
                        players_to_go = [gmv[2]];
                      }
                    } catch (err) {
                      players_to_go = gmv[1];
                    }
                  }
                  for (_i = 0; _i < players_to_go.length; _i++) {
                    if (game_self.game.player == _i + 1) {
                      game_self.hud.back_button = false;
                      game_self.updateStatus(gmv[1]);
                    }
                  }
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context9.a(2, 1);
            }
          }, _callee9);
        }));
        return function (_x8, _x9) {
          return _ref4.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(game_self, gmv) {
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                if (gmv[0] === 'LOAD') {
                  //console.log("LOAD not supported in game engine - see saveload module");
                }
                return _context0.a(2, 1);
            }
          }, _callee0);
        }));
        return function (_x0, _x1) {
          return _ref5.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(game_self, gmv) {
          var game_id, backup_game, i, loadurl;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                if (gmv[0] === 'SAVE') {
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  if (!game_self.app.options.saves) {
                    game_self.app.options.saves = {};
                  }

                  //
                  // we don't save from the LIVE version as we may have executed commands
                  //
                  // we save from the SAVED version in the options file
                  //
                  game_id = game_self.game.id;
                  backup_game = JSON.parse(JSON.stringify(game_self.game));
                  for (i = 0; i < _this.app.options.games.length; i++) {
                    if (_this.app.options.games[i].id === game_id) {
                      backup_game = JSON.parse(JSON.stringify(_this.app.options.games[i]));
                      i = _this.app.options.games.length + 1;
                    }
                  }
                  backup_game.queue.push("ACKNOWLEDGE\tGame Reloaded. Please confirm all players have reloaded before clicking to continue.");
                  game_self.app.options.saves[game_self.game.id] = backup_game;
                  loadurl = _this.app.browser.protocol + '//' + _this.app.browser.host;
                  game_self.updateLog("<p></p>This game has been saved. To restore from this point, all players should visit the following URL:<p></p>&nbsp;<p></p><div style=\"overflow:auto;word-wrap:break-word\">".concat(loadurl, "/").concat(game_self.returnSlug(), "?load=").concat(game_self.game.id, "&noload=true</div><p></p>&nbsp;<p></p>"));

                  //
                  // is it safe to save here?
                  //
                  game_self.app.storage.saveOptions();
                }
                return _context1.a(2, 1);
            }
          }, _callee1);
        }));
        return function (_x10, _x11) {
          return _ref6.apply(this, arguments);
        };
      }());

      /*
       * this just returns 0 - it needs to be cleared through RESOLVE
       * used for faster_play experiment in HIS, can consider moving
       * into game engine if succeeds
       */
      this.commands.push(/*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(game_self, gmv) {
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                if (!(gmv[0] === 'HALTED')) {
                  _context10.n = 2;
                  break;
                }
                if (!_this.areMoreConfirmsNeeded()) {
                  _context10.n = 1;
                  break;
                }
                game_self.updateStatus('waiting for opponent...');
                return _context10.a(2, 0);
              case 1:
                return _context10.a(2, 1);
              case 2:
                return _context10.a(2, 1);
            }
          }, _callee10);
        }));
        return function (_x12, _x13) {
          return _ref7.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(game_self, gmv) {
          var notice, player, playerAlt, my_specific_game_id;
          return _regenerator().w(function (_context12) {
            while (1) switch (_context12.n) {
              case 0:
                if (!(gmv[0] === 'ACKNOWLEDGE')) {
                  _context12.n = 4;
                  break;
                }
                notice = gmv[1];
                player = gmv[2]; // optional = which player must acknowledge to continue, or array of players
                // Don't process in Background
                if (game_self.gameBrowserActive()) {
                  _context12.n = 1;
                  break;
                }
                playerAlt = player || _this.game.player; // Send notification
                game_self.setPlayerActive(playerAlt);
                return _context12.a(2, 0);
              case 1:
                // prevent back button on any HUD
                game_self.unbindBackButtonFunction();
                game_self.saveGame(game_self.game.id);
                if (!(game_self.game.player == 0)) {
                  _context12.n = 2;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                game_self.hud.back_button = false;
                game_self.updateStatusAndListCards(notice);
                return _context12.a(2, 1);
              case 2:
                if (!player) {
                  _context12.n = 3;
                  break;
                }
                if (!(parseInt(player) > 0)) {
                  _context12.n = 3;
                  break;
                }
                if (!(_this.game.player != parseInt(player))) {
                  _context12.n = 3;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context12.a(2, 1);
              case 3:
                game_self.halted = 1;
                my_specific_game_id = game_self.game.id; // set active player
                game_self.setPlayerActive();
                game_self.playerAcknowledgeNotice(notice, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
                  return _regenerator().w(function (_context11) {
                    while (1) switch (_context11.n) {
                      case 0:
                        game_self.updateStatus('acknowledged...');

                        //
                        // it can be computationally expensive to restart the queue, so we
                        // provide a slight window which allows the status/hud to update
                        // before we continue throwing work at the CPU.
                        //
                        setTimeout(function () {
                          if (game_self.game.id != my_specific_game_id) {
                            game_self.game = game_self.loadGame(my_specific_game_id);
                          }
                          game_self.acknowledge_overlay.hide();
                          game_self.hud.back_button = false;
                          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                          game_self.restartQueue();
                          return 1;
                        }, 0);
                      case 1:
                        return _context11.a(2);
                    }
                  }, _callee11);
                })));
                return _context12.a(2, 0);
              case 4:
                return _context12.a(2, 1);
            }
          }, _callee12);
        }));
        return function (_x14, _x15) {
          return _ref8.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(game_self, gmv) {
          return _regenerator().w(function (_context13) {
            while (1) switch (_context13.n) {
              case 0:
                if (!(gmv[0] === 'SETTLE')) {
                  _context13.n = 1;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                game_self.queueGameStakeSettlement();
                return _context13.a(2, 1);
              case 1:
                return _context13.a(2, 1);
            }
          }, _callee13);
        }));
        return function (_x16, _x17) {
          return _ref0.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(game_self, gmv) {
          return _regenerator().w(function (_context14) {
            while (1) switch (_context14.n) {
              case 0:
                if (!(gmv[0] === 'GAMEOVER')) {
                  _context14.n = 1;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                game_self.game.terminating = 0;
                game_self.game.over = 1;
                game_self.game.last_block = game_self.app.blockchain.last_bid;
                if (game_self.gameBrowserActive()) {
                  game_self.gameOverUserInterface();
                } else {
                  if (game_self.game.reason !== 'cancellation') {
                    siteMessage(game_self.game.module + ': Game Over', 5000);
                    game_self.app.connection.emit('arcade-invite-manager-render-request');
                  }
                }
                game_self.saveGame(game_self.game.id);
                return _context14.a(2, 0);
              case 1:
                return _context14.a(2, 1);
            }
          }, _callee14);
        }));
        return function (_x18, _x19) {
          return _ref1.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(game_self, gmv) {
          var winner, reason, losers, players, _iterator, _step, p, _game_self$game, _game_self$game$optio, newtx, _game_self$game2;
          return _regenerator().w(function (_context15) {
            while (1) switch (_context15.n) {
              case 0:
                if (!(gmv[0] === 'ROUNDOVER')) {
                  _context15.n = 4;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                winner = JSON.parse(gmv[1]);
                reason = gmv[2];
                losers = gmv[3] ? JSON.parse(gmv[3]) : null;
                players = [];
                if (losers) {
                  _iterator = _createForOfIteratorHelper(winner.concat(losers));
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      p = _step.value;
                      if (!players.includes(p)) {
                        players.push(p);
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                } else {
                  players = game_self.game.players;
                }
                if (!(game_self.game.players[0] == game_self.publicKey)) {
                  _context15.n = 3;
                  break;
                }
                _context15.n = 1;
                return game_self.app.wallet.createUnsignedTransactionWithDefaultFee();
              case 1:
                newtx = _context15.v;
                newtx.addTo(game_self.publicKey);
                /* This is exactly like gameover so League can process */
                newtx.msg = {
                  request: 'roundover',
                  game_id: game_self.game.id,
                  winner: winner,
                  players: players.join('_'),
                  module: game_self.game.module,
                  reason: reason,
                  step: (_game_self$game = game_self.game) === null || _game_self$game === void 0 || (_game_self$game = _game_self$game.step) === null || _game_self$game === void 0 ? void 0 : _game_self$game.game,
                  ts: new Date().getTime()
                };
                if ((_game_self$game$optio = game_self.game.options) !== null && _game_self$game$optio !== void 0 && _game_self$game$optio.league_id) {
                  newtx.msg.league_id = (_game_self$game2 = game_self.game) === null || _game_self$game2 === void 0 || (_game_self$game2 = _game_self$game2.options) === null || _game_self$game2 === void 0 ? void 0 : _game_self$game2.league_id;
                }
                _context15.n = 2;
                return newtx.sign();
              case 2:
                //Send message
                game_self.app.network.propagateTransaction(newtx);
              case 3:
                return _context15.a(2, 1);
              case 4:
                return _context15.a(2, 1);
            }
          }, _callee15);
        }));
        return function (_x20, _x21) {
          return _ref10.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(game_self, gmv) {
          var msgobj, msg;
          return _regenerator().w(function (_context16) {
            while (1) switch (_context16.n) {
              case 0:
                if (gmv[0] === 'OBSERVER') {
                  msgobj = {
                    game_id: game_self.game.id,
                    player: game_self.publicKey,
                    module: game_self.game.module
                  };
                  msg = game_self.app.crypto.stringToBase64(JSON.stringify(msgobj));
                  try {
                    //
                    // OBSOLETE MSG -- keeping code so reference for improvements here though
                    //
                    //  game_self.displayModal("Observer Mode now Active");
                    //  game_self.updateLog(`Player ${game_self.game.player} has enabled observer mode. This can leak data on your private hand to your opponent.`);
                  } catch (err) {}
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context16.a(2, 1);
            }
          }, _callee16);
        }));
        return function (_x22, _x23) {
          return _ref11.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(game_self, gmv) {
          var players_to_go, i, reset_confirmations, _i2, can_i_go, _i3;
          return _regenerator().w(function (_context17) {
            while (1) switch (_context17.n) {
              case 0:
                if (!(gmv[0] === 'PLAY')) {
                  _context17.n = 4;
                  break;
                }
                players_to_go = [];
                if (gmv[1] === 'all') {
                  for (i = 0; i < game_self.game.players.length; i++) {
                    players_to_go.push(i + 1);
                  }
                } else {
                  try {
                    if (gmv[1].isArray()) {
                      players_to_go = gmv[1];
                    } else {
                      players_to_go = [gmv[1]];
                    }
                  } catch (err) {
                    players_to_go = gmv[1];
                  }
                }

                //
                // reset confs if we do not have confirms_needed
                //
                reset_confirmations = 1;
                for (_i2 = 0; _i2 < game_self.game.confirms_needed.length; _i2++) {
                  if (game_self.game.confirms_needed[_i2] == 1) {
                    reset_confirmations = 0;
                  }
                }
                if (reset_confirmations == 1) {
                  game_self.resetConfirmsNeeded(players_to_go);
                }
                can_i_go = 0;
                _i3 = 0;
              case 1:
                if (!(_i3 < players_to_go.length)) {
                  _context17.n = 3;
                  break;
                }
                if (!(game_self.game.player == parseInt(players_to_go[_i3]))) {
                  _context17.n = 2;
                  break;
                }
                can_i_go = 1;
                if (!(game_self.game.confirms_needed[players_to_go[_i3] - 1] == 1)) {
                  _context17.n = 2;
                  break;
                }
                _context17.n = 2;
                return game_self.playerTurn();
              case 2:
                _i3++;
                _context17.n = 1;
                break;
              case 3:
                if (can_i_go == 0) {
                  game_self.nonPlayerTurn();
                }
                return _context17.a(2, 0);
              case 4:
                return _context17.a(2, 1);
            }
          }, _callee17);
        }));
        return function (_x24, _x25) {
          return _ref12.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(game_self, gmv) {
          var players_to_go, i, reset_confirmations, _i4;
          return _regenerator().w(function (_context18) {
            while (1) switch (_context18.n) {
              case 0:
                if (!(gmv[0] === 'RESETCONFIRMSNEEDED')) {
                  _context18.n = 2;
                  break;
                }
                if (!_this.isGameHalted()) {
                  _context18.n = 1;
                  break;
                }
                //
                // we are HALTED, so we should
                //
                _this.updateStatus('Waiting for Other Players');
                return _context18.a(2, 0);
              case 1:
                players_to_go = [];
                if (gmv[1] === 'all') {
                  for (i = 0; i < game_self.game.players.length; i++) {
                    players_to_go.push(i + 1);
                  }
                  game_self.resetConfirmsNeeded(players_to_go);
                } else {
                  try {
                    if (Array.isArray(gmv[1])) {
                      console.log('setting 1 here: ' + gmv[1]);
                      players_to_go = gmv[1];
                    } else {
                      if (Array.isArray(JSON.parse(gmv[1]))) {
                        console.log('setting 2-1 here: ' + gmv[1]);
                        players_to_go = JSON.parse(gmv[1]);
                      } else {
                        console.log('setting 2-2 here: ' + gmv[1]);
                        players_to_go = [gmv[1]];
                      }
                    }
                  } catch (err) {
                    console.log('setting 3 here: ' + gmv[1]);
                    players_to_go = gmv[1];
                  }
                }

                //
                // reset confs if we do not have confirms_needed
                //
                console.log('RESET CONFS NEEDED: ' + JSON.stringify(players_to_go));
                reset_confirmations = 1;
                for (_i4 = 0; _i4 < game_self.game.confirms_needed.length; _i4++) {
                  if (game_self.game.confirms_needed[_i4] == 1) {
                    console.log('not resetting!');
                    reset_confirmations = 0;
                  }
                }
                if (reset_confirmations == 1) {
                  console.log('ok resetting... ' + JSON.stringify(players_to_go));
                  game_self.resetConfirmsNeeded(players_to_go);
                }

                //
                // remove this instruction
                //
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context18.a(2, 1);
              case 2:
                return _context18.a(2, 1);
            }
          }, _callee18);
        }));
        return function (_x26, _x27) {
          return _ref13.apply(this, arguments);
        };
      }());

      //
      // [RESOLVE]
      // or
      // [RESOLVE \t publickey] (multi-player simulatenous)
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(game_self, gmv) {
          var i, gle, resolve_queue, _i5, msg, notice, am_i_still_to_move, anyone_left_to_move, _i6, is_halted_cmd, halted_cmd_idx, z, _gle, _gle2;
          return _regenerator().w(function (_context19) {
            while (1) switch (_context19.n) {
              case 0:
                if (!(gmv[0] === 'RESOLVE')) {
                  _context19.n = 11;
                  break;
                }
                //
                // debugging
                //
                console.log('confs_needed pre_RESOLVE handling: ' + JSON.stringify(game_self.game.confirms_needed));

                //
                // resolve coming from specific player
                //
                if (!gmv[1]) {
                  _context19.n = 1;
                  break;
                }
                console.log('RESOLVE: from ' + gmv[1]);
                for (i = 0; i < game_self.game.players.length; i++) {
                  if (game_self.game.players[i] === gmv[1]) {
                    game_self.game.confirms_needed[i] = 0;
                  }
                }
                _context19.n = 5;
                break;
              case 1:
                if (!(game_self.game.queue.length - 1 == 0)) {
                  _context19.n = 2;
                  break;
                }
                game_self.game.queue = [];
                return _context19.a(2, 1);
              case 2:
                gle = game_self.game.queue.length - 2;
                if (!(game_self.game.queue[gle] === 'RESOLVE')) {
                  _context19.n = 3;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context19.a(2, 1);
              case 3:
                if (!(gle <= 0)) {
                  _context19.n = 4;
                  break;
                }
                game_self.game.queue = [];
                return _context19.a(2, 1);
              case 4:
                game_self.game.queue.splice(gle, 2);
                return _context19.a(2, 1);
              case 5:
                //
                // resolve previous command if we are not waiting for anyone
                //
                resolve_queue = 1;
                for (_i5 = 0; _i5 < game_self.game.confirms_needed.length; _i5++) {
                  if (game_self.game.confirms_needed[_i5] >= 1) {
                    resolve_queue = 0;
                  }
                }
                console.log('updated confs: ' + JSON.stringify(game_self.game.confirms_needed) + ' (' + resolve_queue + ')');
                msg = 'Players still to move:';
                notice = '<ul>';
                am_i_still_to_move = 0;
                anyone_left_to_move = 0;
                for (_i6 = 0; _i6 < game_self.game.confirms_needed.length; _i6++) {
                  if (game_self.game.confirms_needed[_i6] == 1) {
                    notice += '<li class="option resolve">' + game_self.returnUsername(game_self.game.players[_i6]) + '</li>';
                    anyone_left_to_move = 1;
                  }
                  if (game_self.game.player == _i6 + 1) {
                    am_i_still_to_move = game_self.game.confirms_needed[_i6];
                  }
                }
                notice += '</ul>';
                if (!am_i_still_to_move && anyone_left_to_move) {
                  game_self.hud.back_button = false;
                  game_self.updateStatusWithOptions(msg, notice);
                }

                //
                // return 1 if we remove stuff
                //
                if (!(resolve_queue == 1)) {
                  _context19.n = 10;
                  break;
                }
                if (!(game_self.game.queue.length - 1 == 0)) {
                  _context19.n = 6;
                  break;
                }
                game_self.game.queue = [];
                return _context19.a(2, 1);
              case 6:
                //
                // HALTED introduces problems with the order in which resolves can arrive
                // so we check to see if there is a HALTED instruction sitting on the queue
                // in which case we REMOVE it, because the RESOLVE is intended for IT and
                // not anything else.
                //
                is_halted_cmd = 0;
                halted_cmd_idx = 0;
                for (z = game_self.game.queue.length - 1; z >= 0; z--) {
                  _gle = game_self.game.queue[z].split('\t');
                  if (_gle[0] === 'HALTED') {
                    is_halted_cmd = 1;
                    halted_cmd_idx = z;
                    z = -1;
                  }
                }
                if (!is_halted_cmd) {
                  _context19.n = 7;
                  break;
                }
                // remove RESOLVE
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                if (halted_cmd_idx <= game_self.game.queue.length) {
                  // remove HALTED
                  game_self.game.queue.splice(halted_cmd_idx, 1);
                }
                console.log('CLEAR -- remove halted return 1');
                console.log('continuing with QUEUE: ' + JSON.stringify(game_self.game.queue));
                return _context19.a(2, 1);
              case 7:
                _gle2 = game_self.game.queue.length - 2;
                if (!(game_self.game.queue[_gle2] === 'RESOLVE')) {
                  _context19.n = 8;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                console.log('CLEAR -- remove RESOLVES return 1');
                console.log('continuing with QUEUE: ' + JSON.stringify(game_self.game.queue));
                return _context19.a(2, 1);
              case 8:
                if (!(_gle2 <= 0)) {
                  _context19.n = 9;
                  break;
                }
                game_self.game.queue = [];
                return _context19.a(2, 1);
              case 9:
                game_self.game.queue.splice(_gle2, 2);
                console.log('CLEAR -- remove previous ENTRY return 1');
                console.log('continuing with QUEUE: ' + JSON.stringify(game_self.game.queue));
                return _context19.a(2, 1);
              case 10:
                //
                // queue not resolves
                //
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                console.log('NOT FULLY -- just remove RESOLVE return 1');
                console.log('continuing with QUEUE: ' + JSON.stringify(game_self.game.queue));
                return _context19.a(2, 1);
              case 11:
                return _context19.a(2, 1);
            }
          }, _callee19);
        }));
        return function (_x28, _x29) {
          return _ref14.apply(this, arguments);
        };
      }());

      //
      // [PRERESOLVE \t cmd]
      //
      // inserts cmd in queue for execution after resolve clears
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(game_self, gmv) {
          var i, lmv;
          return _regenerator().w(function (_context20) {
            while (1) switch (_context20.n) {
              case 0:
                if (!(gmv[0] === 'PRERESOLVE')) {
                  _context20.n = 4;
                  break;
                }
                if (!gmv[1]) {
                  _context20.n = 3;
                  break;
                }
                i = game_self.game.queue.length - 1;
              case 1:
                if (!(i >= 0)) {
                  _context20.n = 3;
                  break;
                }
                lmv = game_self.game.queue[i].split('\t');
                if (!(lmv[0] === 'RESOLVE')) {
                  _context20.n = 2;
                  break;
                }
                game_self.game.queue.splice(i - 1, 0, gmv[1]);
                return _context20.a(3, 3);
              case 2:
                i--;
                _context20.n = 1;
                break;
              case 3:
                return _context20.a(2, 1);
              case 4:
                return _context20.a(2, 1);
            }
          }, _callee20);
        }));
        return function (_x30, _x31) {
          return _ref15.apply(this, arguments);
        };
      }());

      //
      //READY is the signal that the game is ready to play.
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(game_self, gmv) {
          return _regenerator().w(function (_context21) {
            while (1) switch (_context21.n) {
              case 0:
                if (!(gmv[0] == 'READY')) {
                  _context21.n = 2;
                  break;
                }
                game_self.game.initializing = 0;
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                game_self.saveGame(game_self.game.id);

                //
                // observer mode
                //
                if (game_self.game.player == 0) {
                  game_self.game_state_pre_move = JSON.parse(JSON.stringify(game_self.game));
                }
                if (!game_self.gameBrowserActive()) {
                  _context21.n = 1;
                  break;
                }
                return _context21.a(2, 1);
              case 1:
                //Otherwise we want to pause game processing
                game_self.treat_all_moves_as_future = 1;
                game_self.emitGameReadyRender();
                // Move into game before processing anything else from the queue or future moves
                game_self.halted = 1;
                return _context21.a(2, 0);
              case 2:
                return _context21.a(2, 1);
            }
          }, _callee21);
        }));
        return function (_x32, _x33) {
          return _ref16.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(game_self, gmv) {
          return _regenerator().w(function (_context22) {
            while (1) switch (_context22.n) {
              case 0:
                if (gmv[0] === 'SHUFFLE') {
                  game_self.shuffleDeck(parseInt(gmv[1]));
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context22.a(2, 1);
            }
          }, _callee22);
        }));
        return function (_x34, _x35) {
          return _ref17.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(game_self, gmv) {
          var deckidx, discarded_cards, i, z, _z;
          return _regenerator().w(function (_context23) {
            while (1) switch (_context23.n) {
              case 0:
                if (gmv[0] === 'SHUFFLEDISCARDS') {
                  deckidx = parseInt(gmv[1]);
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  discarded_cards = {};
                  for (i in game_self.game.deck[deckidx - 1].discards) {
                    discarded_cards[i] = game_self.game.deck[deckidx - 1].cards[i];
                    delete game_self.game.deck[deckidx - 1].cards[i];
                  }
                  game_self.game.deck[deckidx - 1].discards = {};
                  game_self.game.queue.push('SHUFFLE\t' + deckidx);
                  game_self.game.queue.push('DECKRESTORE\t' + deckidx);
                  for (z = game_self.game.players.length; z >= 1; z--) {
                    game_self.game.queue.push('DECKENCRYPT\t' + deckidx + '\t' + z);
                  }
                  for (_z = game_self.game.players.length; _z >= 1; _z--) {
                    game_self.game.queue.push('DECKXOR\t' + deckidx + '\t' + _z);
                  }
                  game_self.game.queue.push('DECK\t' + deckidx + '\t' + JSON.stringify(discarded_cards));
                  game_self.game.queue.push('DECKBACKUP\t' + deckidx);
                }
                return _context23.a(2, 1);
            }
          }, _callee23);
        }));
        return function (_x36, _x37) {
          return _ref18.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(game_self, gmv) {
          var deckidx;
          return _regenerator().w(function (_context24) {
            while (1) switch (_context24.n) {
              case 0:
                if (gmv[0] === 'LOGDECK') {
                  deckidx = parseInt(gmv[1]);
                  game_self.updateLog("Contents of Deck: ".concat(JSON.stringify(game_self.game.deck[deckidx - 1].crypt)));
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context24.a(2, 1);
            }
          }, _callee24);
        }));
        return function (_x38, _x39) {
          return _ref19.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(game_self, gmv) {
          var deckidx;
          return _regenerator().w(function (_context25) {
            while (1) switch (_context25.n) {
              case 0:
                if (gmv[0] === 'LOGHAND') {
                  deckidx = parseInt(gmv[1]);
                  game_self.updateLog("Contents of Hand: ".concat(game_self.game.deck[deckidx - 1].hand));
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context25.a(2, 1);
            }
          }, _callee25);
        }));
        return function (_x40, _x41) {
          return _ref20.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(game_self, gmv) {
          var poolidx;
          return _regenerator().w(function (_context26) {
            while (1) switch (_context26.n) {
              case 0:
                if (gmv[0] === 'LOGPOOL') {
                  poolidx = parseInt(gmv[1]);
                  game_self.updateLog("Contents of Pool: ".concat(game_self.game.pool[poolidx - 1].hand));
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context26.a(2, 1);
            }
          }, _callee26);
        }));
        return function (_x42, _x43) {
          return _ref21.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(game_self, gmv) {
          var deckidx, card, handidx;
          return _regenerator().w(function (_context27) {
            while (1) switch (_context27.n) {
              case 0:
                if (gmv[0] == 'DISCARD') {
                  deckidx = parseInt(gmv[1]);
                  card = gmv[2];
                  handidx = game_self.game.deck[deckidx - 1].hand.indexOf(card);
                  if (handidx > -1) {
                    game_self.game.deck[deckidx - 1].hand.splice(handidx, 1);
                  }
                  game_self.game.deck[deckidx - 1].discards[card] = game_self.game.deck[deckidx - 1].cards[card];
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context27.a(2, 1);
            }
          }, _callee27);
        }));
        return function (_x44, _x45) {
          return _ref22.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref23 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(game_self, gmv) {
          var deckidx, recipient, cards, i, newcard;
          return _regenerator().w(function (_context28) {
            while (1) switch (_context28.n) {
              case 0:
                if (!(gmv[0] === 'RESOLVEDEAL')) {
                  _context28.n = 2;
                  break;
                }
                deckidx = parseInt(gmv[1]);
                recipient = parseInt(gmv[2]);
                cards = parseInt(gmv[3]);
                if (game_self.game.player == recipient) {
                  // card must exist
                  if (game_self.game.deck[deckidx - 1].crypt.length >= cards) {
                    for (i = 0; i < cards; i++) {
                      newcard = game_self.game.deck[deckidx - 1].crypt[i]; //
                      // if we have a key, this is encrypted
                      //
                      if (game_self.game.deck[deckidx - 1].keys[i] != undefined) {
                        newcard = game_self.app.crypto.decodeXOR(newcard, game_self.game.deck[deckidx - 1].keys[i]);
                      }
                      newcard = game_self.app.crypto.hexToString(newcard);

                      //NOTE: Each card in the deck must be unique
                      if (!game_self.game.deck[deckidx - 1].hand.includes(newcard)) {
                        game_self.game.deck[deckidx - 1].hand.push(newcard);
                      }

                      //
                      // removed July 4, 2010 as error removed
                      //
                      //              //Sanity check
                      //              if (!game_self.game.deck[deckidx - 1].cards[newcard]) {
                      //                console.warn(
                      //                  'GT [RESOLVEDEAL]: Card decryption error!',
                      //                  'Card: ' + newcard,
                      //                  'deck:',
                      //                  JSON.parse(JSON.stringify(game_self.game.deck[deckidx - 1]))
                      //                );
                      //                if (game_self.app.BROWSER) {
                      //                  siteMessage('There was a decryption error which will make the game unplayable');
                      //                }
                      //              }
                    }
                  }
                }
                if (game_self.game.queue.length < 2) {
                  game_self.game.queue = [];
                } else {
                  game_self.game.queue.splice(game_self.game.queue.length - 2, 2);
                }

                //
                // everyone purges their spent keys
                //
                if (!(game_self.game.issued_keys_deleted == 0)) {
                  _context28.n = 2;
                  break;
                }
                if (!(game_self.game.player == 0)) {
                  _context28.n = 1;
                  break;
                }
                game_self.game.deck[deckidx - 1].crypt.splice(0, cards);
                game_self.game.issued_keys_deleted = 1;
                return _context28.a(2, 1);
              case 1:
                if (game_self.game.deck[deckidx - 1].keys.length <= cards) {
                  game_self.game.deck[deckidx - 1].keys = [];
                  game_self.game.deck[deckidx - 1].crypt = [];
                } else {
                  game_self.game.deck[deckidx - 1].keys.splice(0, cards);
                  game_self.game.deck[deckidx - 1].crypt.splice(0, cards);
                  if (game_self.game.deck[deckidx - 1].keys.length !== game_self.game.deck[deckidx - 1].crypt.length) {
                    console.warn('GT [RESOLVEDEAL] Key-Crypt mismatch:', JSON.parse(JSON.stringify(game_self.game.deck[deckidx - 1])));
                  }
                }
                game_self.game.issued_keys_deleted = 1;
              case 2:
                return _context28.a(2, 1);
            }
          }, _callee28);
        }));
        return function (_x46, _x47) {
          return _ref23.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(game_self, gmv) {
          var players, cards, deckidx, deck, i, _i7, _i8;
          return _regenerator().w(function (_context29) {
            while (1) switch (_context29.n) {
              case 0:
                if (gmv[0] === 'SIMPLEDEAL') {
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  players = game_self.game.players.length;
                  cards = parseInt(gmv[1]);
                  deckidx = parseInt(gmv[2]);
                  deck = JSON.parse(gmv[3]);
                  for (i = players; i >= 1; i--) {
                    game_self.game.queue.push('DEAL\t' + deckidx + '\t' + i + '\t' + cards);
                  }
                  for (_i7 = players; _i7 >= 1; _i7--) {
                    game_self.game.queue.push('DECKENCRYPT\t' + deckidx + '\t' + _i7);
                  }
                  for (_i8 = players; _i8 >= 1; _i8--) {
                    game_self.game.queue.push('DECKXOR\t' + deckidx + '\t' + _i8);
                  }
                  game_self.game.queue.push('DECK\t' + deckidx + '\t' + JSON.stringify(deck));
                }
                return _context29.a(2, 1);
            }
          }, _callee29);
        }));
        return function (_x48, _x49) {
          return _ref24.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(game_self, gmv) {
          var deckidx, recipient, cards, z, c, total_players, i;
          return _regenerator().w(function (_context30) {
            while (1) switch (_context30.n) {
              case 0:
                if (!(gmv[0] === 'DEAL')) {
                  _context30.n = 2;
                  break;
                }
                deckidx = parseInt(gmv[1]);
                recipient = parseInt(gmv[2]);
                cards = parseInt(gmv[3]); //
                // async_dealing triggers a simpler and less secure form of card/deck dealing which
                // exposes knowledge of player hands and deck contents to all players but eliminates
                // the need for all players to be simultaneously online, thus more suitable for
                // some async games.
                //
                if (!(game_self.async_dealing == 1)) {
                  _context30.n = 1;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                for (z = 0; z < cards; z++) {
                  if (game_self.game.deck[deckidx - 1].crypt.length > 0) {
                    c = game_self.game.deck[deckidx - 1].crypt[0];
                    c = game_self.app.crypto.hexToString(c);
                    if (game_self.game.player == recipient) {
                      if (!game_self.game.deck[deckidx - 1].hand.includes(c)) {
                        game_self.game.deck[deckidx - 1].hand.push(c);
                      }
                    }
                    game_self.game.deck[deckidx - 1].crypt.shift();
                  }
                }
                return _context30.a(2, 1);
              case 1:
                //
                // resolvedeal checks this when
                // deleting the keys from its
                // crypt.
                //
                game_self.game.issued_keys_deleted = 0;
                total_players = game_self.game.players.length; //
                // do not permit dealing more keys than exist in this deck
                //
                if (_this.game.player > 0) {
                  if (game_self.game.deck[deckidx - 1].keys.length < cards) {
                    cards = game_self.game.deck[deckidx - 1].keys.length;
                  }
                }

                // if the total players is 1 -- solo game
                if (total_players == 1) {
                  game_self.game.queue.push('RESOLVEDEAL\t' + deckidx + '\t' + recipient + '\t' + cards);
                } else {
                  game_self.game.queue.push('RESOLVEDEAL\t' + deckidx + '\t' + recipient + '\t' + cards);
                  for (i = 1; i <= total_players; i++) {
                    if (i != recipient) {
                      //The recipient decodes last (without broadcasting their keys so other players cannot snoop)
                      game_self.game.queue.push('REQUESTKEYS\t' + deckidx + '\t' + i + '\t' + recipient + '\t' + cards);
                    }
                  }
                }
              case 2:
                return _context30.a(2, 1);
            }
          }, _callee30);
        }));
        return function (_x50, _x51) {
          return _ref25.apply(this, arguments);
        };
      }());

      //
      // SAFEDEAL shuffles discards back into the deck before dealing
      // if necessary and discards are available. if there are no more
      // cards to be dealt, it ends the game.
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(game_self, gmv) {
          var deckidx, recipient, cards_to_deal, cards_to_deal_first, cards_to_deal_after, discarded_cards, i, z, _z2;
          return _regenerator().w(function (_context31) {
            while (1) switch (_context31.n) {
              case 0:
                if (gmv[0] === 'SAFEDEAL') {
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  deckidx = parseInt(gmv[1]);
                  recipient = parseInt(gmv[2]);
                  cards_to_deal = parseInt(gmv[3]); //
                  // check we have enough cards in this deck
                  //
                  if (game_self.game.deck[deckidx - 1].crypt.length >= cards_to_deal) {
                    _this.game.queue.push('DEAL\t' + deckidx + '\t' + recipient + '\t' + cards_to_deal);
                  } else {
                    cards_to_deal_first = game_self.game.deck[deckidx - 1].crypt.length;
                    cards_to_deal_after = cards_to_deal - cards_to_deal_first;
                    discarded_cards = {};
                    for (i in game_self.game.deck[deckidx - 1].discards) {
                      discarded_cards[i] = game_self.game.deck[deckidx - 1].cards[i];
                      delete game_self.game.deck[deckidx - 1].cards[i];
                    }
                    game_self.game.deck[deckidx - 1].discards = {};
                    if (Object.keys(discarded_cards).length <= 0) {
                      game_self.updateLog('skipping deal - no cards available and no discards for reshuffling');
                    } else {
                      game_self.game.queue.push('DEAL\t' + deckidx + '\t' + recipient + '\t' + cards_to_deal_after);
                      //
                      // shuffle in discarded cards
                      //
                      game_self.game.queue.push('SHUFFLE\t' + deckidx);
                      game_self.game.queue.push('DECKRESTORE\t' + deckidx);
                      for (z = game_self.game.players.length; z >= 1; z--) {
                        game_self.game.queue.push('DECKENCRYPT\t' + deckidx + '\t' + z);
                      }
                      for (_z2 = game_self.game.players.length; _z2 >= 1; _z2--) {
                        game_self.game.queue.push('DECKXOR\t' + deckidx + '\t' + _z2);
                      }
                      // DECKFLUSH not needed as we are all executing this
                      game_self.game.queue.push('DECK\t' + deckidx + '\t' + JSON.stringify(discarded_cards));
                      game_self.game.queue.push('DECKBACKUP\t' + deckidx);
                      if (cards_to_deal_first > 0) {
                        game_self.game.queue.push('DEAL\t' + deckidx + '\t' + recipient + '\t' + cards_to_deal_first);
                      }
                    }
                  }
                }
                return _context31.a(2, 1);
            }
          }, _callee31);
        }));
        return function (_x52, _x53) {
          return _ref26.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(game_self, gmv) {
          var deckidx, z, _z3;
          return _regenerator().w(function (_context32) {
            while (1) switch (_context32.n) {
              case 0:
                if (gmv[0] === 'PUSHONDECK') {
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  deckidx = parseInt(gmv[1]); //game_self.game.queue.push("LOGDECK\t"+deckidx);
                  game_self.game.queue.push("DECKRESTORE\t".concat(deckidx, "\tpush"));
                  for (z = game_self.game.players.length; z >= 1; z--) {
                    game_self.game.queue.push('DECKENCRYPT\t' + deckidx + '\t' + z);
                  }
                  for (_z3 = game_self.game.players.length; _z3 >= 1; _z3--) {
                    game_self.game.queue.push('DECKXOR\t' + deckidx + '\t' + _z3);
                  }
                  game_self.game.queue.push('DECK\t' + deckidx + '\t' + gmv[2]);
                  game_self.game.queue.push('DECKBACKUP\t' + deckidx);
                  //game_self.game.queue.push("LOGDECK\t"+deckidx);
                }
                return _context32.a(2, 1);
            }
          }, _callee32);
        }));
        return function (_x54, _x55) {
          return _ref27.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref28 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(game_self, gmv) {
          var deckidx, sender, recipient, cards, i;
          return _regenerator().w(function (_context33) {
            while (1) switch (_context33.n) {
              case 0:
                if (!(gmv[0] === 'REQUESTKEYS')) {
                  _context33.n = 2;
                  break;
                }
                deckidx = parseInt(gmv[1]);
                sender = parseInt(gmv[2]);
                recipient = parseInt(gmv[3]);
                cards = parseInt(gmv[4]); //number of cards to deal
                // sender should process
                if (!(game_self.game.player !== sender)) {
                  _context33.n = 1;
                  break;
                }
                return _context33.a(2, 0);
              case 1:
                //
                // I sends keys
                //
                game_self.game.turn = [];
                game_self.game.turn.push('RESOLVE');
                for (i = 0; i < cards; i++) {
                  game_self.game.turn.push(game_self.game.deck[deckidx - 1].keys[i]);
                }
                game_self.game.turn.push("ISSUEKEYS\t".concat(deckidx, "\t").concat(sender, "\t").concat(recipient, "\t").concat(cards, "\t").concat(game_self.game.deck[deckidx - 1].keys.length));
                game_self.sendGameMoveTransaction('game', {});
                return _context33.a(2, 0);
              case 2:
                return _context33.a(2, 1);
            }
          }, _callee33);
        }));
        return function (_x56, _x57) {
          return _ref28.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(game_self, gmv) {
          var deckidx, sender, recipient, cards, opponent_deck_length, keyidx, my_deck_length, i;
          return _regenerator().w(function (_context34) {
            while (1) switch (_context34.n) {
              case 0:
                if (gmv[0] === 'ISSUEKEYS') {
                  deckidx = parseInt(gmv[1]);
                  sender = parseInt(gmv[2]);
                  recipient = parseInt(gmv[3]);
                  cards = parseInt(gmv[4]); // how many keys the other player has
                  opponent_deck_length = parseInt(gmv[5]);
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  keyidx = game_self.game.queue.length - cards;
                  my_deck_length = game_self.game.deck[deckidx - 1].crypt.length;
                  if (game_self.game.player == recipient) {
                    if (my_deck_length == opponent_deck_length) {
                      for (i = 0; i < cards; i++) {
                        if (game_self.game.queue[keyidx + i] != null) {
                          game_self.game.deck[deckidx - 1].crypt[i] = game_self.app.crypto.decodeXOR(game_self.game.deck[deckidx - 1].crypt[i], game_self.game.queue[keyidx + i]);
                        }
                      }
                    } else {
                      console.warn('GT [ISSUEKEYS] issue: deck lengths mismatch');
                    }
                  }

                  //
                  // this avoids splicing out valuable instructions if no cards left
                  //
                  if (cards > 0) {
                    game_self.game.queue.splice(keyidx, cards);
                  }
                }
                return _context34.a(2, 1);
            }
          }, _callee34);
        }));
        return function (_x58, _x59) {
          return _ref29.apply(this, arguments);
        };
      }());

      //
      // SECUREROLL player [hash] [sig_affirming_hash]
      //
      // designed to be stateless, so that if initiating player forgets their commit hash, we fallback
      // to the other players.
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref30 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35(game_self, gmv) {
          var player, hash, sig, players, hashes, move, i, sr, initiating_player, initiating_hash, do_we_have_all_players, has_initiating_player_committed_two_hashes, does_second_hash_hash_to_first, y, player_found, z, hash1, hash1_sig, originating_player, originating_hash, their_second_hash, _z4, hash_sig, new_random, _z5, _i9, _sr, _t3, _t4, _t5, _t6;
          return _regenerator().w(function (_context35) {
            while (1) switch (_context35.n) {
              case 0:
                if (!(gmv[0] === 'SECUREROLL')) {
                  _context35.n = 24;
                  break;
                }
                player = parseInt(gmv[1]);
                hash = gmv[2];
                sig = gmv[3];
                players = [];
                hashes = [];
                move = '';
                i = game_self.game.queue.length - 1;
              case 1:
                if (!(i >= 0)) {
                  _context35.n = 7;
                  break;
                }
                sr = game_self.game.queue[i].split('\t');
                if (!(sr[0] === 'SECUREROLL')) {
                  _context35.n = 4;
                  break;
                }
                if (!(game_self.app.crypto.verifyMessage(sr[2], sr[3], game_self.game.players[sr[1] - 1]) == true)) {
                  _context35.n = 2;
                  break;
                }
                players.push(sr[1]);
                hashes.push(sr[2]);
                _context35.n = 3;
                break;
              case 2:
                console.warn('GT [SECUREROLL] SIG DOES NOT VERIFY ' + sr[2] + ' / ' + sr[3] + ' / ' + game_self.game.players[sr[1] - 1]);
                return _context35.a(2, 0);
              case 3:
                _context35.n = 6;
                break;
              case 4:
                if (!(sr[0] === 'SECUREROLL_END')) {
                  _context35.n = 5;
                  break;
                }
                return _context35.a(3, 7);
              case 5:
                // normal move requiring hash
                move += game_self.game.queue[i];
              case 6:
                i--;
                _context35.n = 1;
                break;
              case 7:
                //
                // at this point we have the game move to be executed in a single string so it can
                // be hashed and used as an input. any changes to the moves broadcast would result
                // in a different hash.
                //
                //
                // our players and hashes array contains the hashes of all players who have already
                // broadcast them AND -- if we are ready to continue -- two hashes from the initiating
                // player which validate each other and demonstrate the initiating player has not
                // attempted to game the random-number selection mechanism.
                //
                // players <--- numbers
                // hashes <--- submitted hashes
                //
                // game.sroll <--- 1 when requesting secureroll
                // game.sroll_hash <--- prehash that needs remembering for initiating player
                // game.sroll_done <--- have I broadcast my contribution to randgen?
                //
                //
                // the last player in the array will be the one who started the SECUREROLL request
                // as theirs (the first) will be the last hash added to our array. so we can use
                // this technique to identify the originating player in a stateless fashion.
                //
                initiating_player = players[players.length - 1];
                initiating_hash = hashes[hashes.length - 1]; //
                //
                //
                do_we_have_all_players = 1;
                has_initiating_player_committed_two_hashes = 0;
                does_second_hash_hash_to_first = 0;
                y = 1;
              case 8:
                if (!(y <= game_self.game.players.length)) {
                  _context35.n = 10;
                  break;
                }
                player_found = 0;
                for (z = 0; z < players.length; z++) {
                  if (players[z] == y) {
                    player_found = 1;
                  }
                }
                if (!(player_found == 0)) {
                  _context35.n = 9;
                  break;
                }
                do_we_have_all_players = 0;
                return _context35.a(3, 10);
              case 9:
                y++;
                _context35.n = 8;
                break;
              case 10:
                if (!(game_self.game.sroll_done == 0)) {
                  _context35.n = 12;
                  break;
                }
                if (!(game_self.game.player != initiating_player)) {
                  _context35.n = 12;
                  break;
                }
                //
                // contribute my own random number
                //
                hash1 = game_self.app.crypto.hash(Math.random());
                _t3 = game_self.app.crypto;
                _t4 = hash1;
                _context35.n = 11;
                return game_self.app.wallet.getPrivateKey();
              case 11:
                hash1_sig = _t3.signMessage.call(_t3, _t4, _context35.v);
                game_self.addMove('SECUREROLL\t' + game_self.game.player + '\t' + hash1 + '\t' + hash1_sig);
                game_self.game.sroll_done = 1;
                game_self.endTurn();
                return _context35.a(2, 0);
              case 12:
                if (!(do_we_have_all_players == 0)) {
                  _context35.n = 13;
                  break;
                }
                return _context35.a(2, 0);
              case 13:
                //
                // now we have all players, so find out
                //
                // has originating player send double commit
                //
                originating_player = players[players.length - 1];
                originating_hash = hashes[players.length - 1];
                their_second_hash = '';
                for (_z4 = 0; _z4 < players.length - 1; _z4++) {
                  if (players[_z4] == originating_player) {
                    their_second_hash = hashes[_z4];
                  }
                }

                //
                //
                //
                if (!(their_second_hash === '')) {
                  _context35.n = 16;
                  break;
                }
                if (!(game_self.game.player == originating_player)) {
                  _context35.n = 15;
                  break;
                }
                _t5 = game_self.app.crypto;
                _t6 = game_self.game.sroll_hash;
                _context35.n = 14;
                return game_self.app.wallet.getPrivateKey();
              case 14:
                hash_sig = _t5.signMessage.call(_t5, _t6, _context35.v);
                game_self.addMove('SECUREROLL\t' + game_self.game.player + '\t' + game_self.game.sroll_hash + '\t' + hash_sig);
                game_self.game.sroll_done = 1;
                game_self.endTurn();
                return _context35.a(2, 0);
              case 15:
                return _context35.a(2, 0);
              case 16:
                if (!(game_self.app.crypto.hash(their_second_hash) === originating_hash)) {
                  _context35.n = 21;
                  break;
                }
                new_random = game_self.app.crypto.hash(move);
                for (_z5 = 0; _z5 < hashes.length; _z5++) {
                  new_random = game_self.app.crypto.hash(new_random + hashes[_z5]);
                }
                game_self.game.dice = new_random;

                //
                // we have updated the dice to a new random, so we can
                // remove the SECUREROLL components. One this is done we
                // can return 1 to continue the move!
                //
                _i9 = game_self.game.queue.length - 1;
              case 17:
                if (!(_i9 >= 0)) {
                  _context35.n = 20;
                  break;
                }
                _sr = game_self.game.queue[_i9].split('\t');
                if (!(_sr[0] === 'SECUREROLL')) {
                  _context35.n = 18;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                _context35.n = 19;
                break;
              case 18:
                return _context35.a(3, 20);
              case 19:
                _i9--;
                _context35.n = 17;
                break;
              case 20:
                return _context35.a(2, 1);
              case 21:
                alert('ERROR: the player which triggered the secure-dice-roll did not submit a second hash which hashed to their original commit. This invalidates the security of the random number generation. Halting.');
              case 22:
                return _context35.a(2, 0);
              case 23:
                return _context35.a(2, 0);
              case 24:
                return _context35.a(2, 1);
            }
          }, _callee35);
        }));
        return function (_x60, _x61) {
          return _ref30.apply(this, arguments);
        };
      }());
      //
      // remove for natural fallthrough
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref31 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36(game_self, gmv) {
          return _regenerator().w(function (_context36) {
            while (1) switch (_context36.n) {
              case 0:
                if (gmv[0] === 'SECUREROLL_END') {
                  // reset for next time
                  game_self.game.sroll = 0;
                  game_self.game.sroll_hash = '';
                  game_self.game.sroll_done = 0;
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context36.a(2, 1);
            }
          }, _callee36);
        }));
        return function (_x62, _x63) {
          return _ref31.apply(this, arguments);
        };
      }());

      //
      // SIMULTANEOUS_PICK player [hash] [sig_affirming_hash]
      //
      // designed to be stateless, so that all information needed to decode the cards
      // ends up on the game queue.
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref32 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37(game_self, gmv) {
          var player, hash, sig, players, hashes, move, i, sr, do_we_have_all_players, do_we_have_me, y, player_found, z, card_sig, hash2, hash2_sig, have_all_players_submitted_three_sigs, _y, commits_found, _z6, player_id, player_card, player_card_set, player_hash_idx, player_hash, k, _i0, _sr2, _t7, _t8, _t9, _t0;
          return _regenerator().w(function (_context37) {
            while (1) switch (_context37.n) {
              case 0:
                if (!(gmv[0] === 'SIMULTANEOUS_PICK')) {
                  _context37.n = 26;
                  break;
                }
                player = parseInt(gmv[1]);
                hash = gmv[2];
                sig = gmv[3];
                players = [];
                hashes = [];
                move = '';
                i = game_self.game.queue.length - 1;
              case 1:
                if (!(i >= 0)) {
                  _context37.n = 6;
                  break;
                }
                sr = game_self.game.queue[i].split('\t');
                if (!(sr[0] === 'SIMULTANEOUS_PICK')) {
                  _context37.n = 4;
                  break;
                }
                if (!(game_self.app.crypto.verifyMessage(sr[2], sr[3], game_self.game.players[sr[1] - 1]) == true)) {
                  _context37.n = 2;
                  break;
                }
                players.push(sr[1]);
                hashes.push(sr[2]);
                _context37.n = 3;
                break;
              case 2:
                console.warn("GT [SIMULTANEOUS_PICK] SIG DOES NOT VERIFY  ".concat(sr[2], " / ").concat(sr[3], " / ").concat(game_self.game.players[sr[1] - 1]));
                return _context37.a(2, 0);
              case 3:
                _context37.n = 5;
                break;
              case 4:
                if (!(sr[0] === 'SIMULTANEOUS_PICK_END')) {
                  _context37.n = 5;
                  break;
                }
                return _context37.a(3, 6);
              case 5:
                i--;
                _context37.n = 1;
                break;
              case 6:
                //
                // the hashes and players array is filled with any submitted moves. we want to wait
                // until all (other) players have submitted their initial commits before we submit
                // our follow-up hash that will unlock our selection.
                //
                //
                // our players and hashes array contains the hashes of all players who have already
                // broadcast them AND -- if we are ready to continue -- two hashes from the initiating
                // player which validate each other and demonstrate the initiating player has not
                // attempted to game the random-number selection mechanism.
                //
                // players <--- numbers
                // hashes <--- submitted hashes
                //
                // game.spick_hash <--- prehash that needs remembering for initiating player
                // game.spick_done <--- have I broadcast my second hash yet?
                //
                //
                // the order of provision does not matter in simulatenous card picks, as all players
                // will / should only submit their unlocking hashes once the other players have
                // submitted at least one hash.
                //
                //
                //
                //
                do_we_have_all_players = 1;
                do_we_have_me = 0;
                y = 1;
              case 7:
                if (!(y <= game_self.game.players.length)) {
                  _context37.n = 9;
                  break;
                }
                player_found = 0;
                for (z = 0; z < players.length; z++) {
                  if (players[z] == y) {
                    player_found = 1;
                    if (z == game_self.game.player - 1) {
                      //should be tested against y, no?
                      do_we_have_me = 1;
                    }
                  }
                }
                if (!(player_found == 0)) {
                  _context37.n = 8;
                  break;
                }
                do_we_have_all_players = 0;
                return _context37.a(3, 9);
              case 8:
                y++;
                _context37.n = 7;
                break;
              case 9:
                if (!(do_we_have_all_players == 0)) {
                  _context37.n = 10;
                  break;
                }
                return _context37.a(2, 0);
              case 10:
                if (!(game_self.game.spick_done == 0)) {
                  _context37.n = 13;
                  break;
                }
                _t7 = game_self.app.crypto;
                _t8 = game_self.game.spick_card;
                _context37.n = 11;
                return game_self.app.wallet.getPrivateKey();
              case 11:
                card_sig = _t7.signMessage.call(_t7, _t8, _context37.v);
                hash2 = game_self.game.spick_hash;
                _t9 = game_self.app.crypto;
                _t0 = hash2;
                _context37.n = 12;
                return game_self.app.wallet.getPrivateKey();
              case 12:
                hash2_sig = _t9.signMessage.call(_t9, _t0, _context37.v);
                game_self.addMove('SIMULTANEOUS_PICK\t' + game_self.game.player + '\t' + hash2 + '\t' + hash2_sig);
                game_self.addMove("SIMULTANEOUS_PICK\t".concat(game_self.game.player, "\t").concat(game_self.game.spick_card, "\t").concat(card_sig));
                game_self.game.spick_done = 1;
                game_self.endTurn();
                return _context37.a(2, 0);
              case 13:
                //
                // have all players submitted all three sigs?
                //
                have_all_players_submitted_three_sigs = 1; //
                // find out
                //
                for (_y = 1; _y <= game_self.game.players.length; _y++) {
                  commits_found = 0;
                  for (_z6 = 0; _z6 < players.length; _z6++) {
                    if (players[_z6] == _y) {
                      commits_found++;
                    }
                  }
                  if (commits_found < 3) {
                    have_all_players_submitted_three_sigs = 0;
                  }
                }

                //
                // keep waiting otherwise
                //
                if (!(have_all_players_submitted_three_sigs == 0)) {
                  _context37.n = 14;
                  break;
                }
                return _context37.a(2, 0);
              case 14:
                //
                // hashes will be on the blockchain in verse order
                //
                game_self.game.state.sp = [];
                player_id = 1;
              case 15:
                if (!(player_id <= game_self.game.players.length)) {
                  _context37.n = 22;
                  break;
                }
                player_card = '';
                player_card_set = 0;
                player_hash_idx = 0;
                player_hash = '';
                k = 0;
              case 16:
                if (!(k < players.length)) {
                  _context37.n = 21;
                  break;
                }
                if (!(players[k] == player_id)) {
                  _context37.n = 20;
                  break;
                }
                player_hash_idx++;
                if (!(player_card_set == 0)) {
                  _context37.n = 17;
                  break;
                }
                player_card = hashes[k];
                player_card_set = 1;
                player_hash = game_self.app.crypto.hash(player_card);
                _context37.n = 20;
                break;
              case 17:
                if (!(player_hash_idx == 2)) {
                  _context37.n = 18;
                  break;
                }
                player_hash = game_self.app.crypto.hash(hashes[k] + player_hash);
                _context37.n = 20;
                break;
              case 18:
                if (!(player_hash != hashes[k])) {
                  _context37.n = 19;
                  break;
                }
                alert('ERROR: Player ' + player_id + ' has submitted inconsistent hash values for their card selection. Halting.');
                return _context37.a(2, 0);
              case 19:
                game_self.game.state.sp[player_id - 1] = player_card;
              case 20:
                k++;
                _context37.n = 16;
                break;
              case 21:
                player_id++;
                _context37.n = 15;
                break;
              case 22:
                _i0 = game_self.game.queue.length - 1;
              case 23:
                if (!(_i0 >= 0)) {
                  _context37.n = 25;
                  break;
                }
                _sr2 = game_self.game.queue[_i0].split('\t');
                while (_sr2[0] === 'SIMULTANEOUS_PICK') {
                  // not just the last entry, but all previous that are SIMPICK
                  game_self.game.queue.splice(_i0, 1);
                  _i0--;
                  _sr2 = game_self.game.queue[_i0].split('\t');
                }
                return _context37.a(3, 25);
              case 24:
                _i0--;
                _context37.n = 23;
                break;
              case 25:
                return _context37.a(2, 1);
              case 26:
                return _context37.a(2, 1);
            }
          }, _callee37);
        }));
        return function (_x64, _x65) {
          return _ref32.apply(this, arguments);
        };
      }());

      //
      // module requires updating
      //
      // TODO -- update copy basic on dynamic contents, hasOwnProperty, etc. not manually
      // this allows for modules to dynamically add their own properties to the deck and
      // have those backed-up as well -- see fhand. Also DECKRESTORE should do reverse.
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref33 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38(game_self, gmv) {
          var deckidx, _i1, i, _i10;
          return _regenerator().w(function (_context38) {
            while (1) switch (_context38.n) {
              case 0:
                if (gmv[0] === 'DECKBACKUP') {
                  deckidx = parseInt(gmv[1]);
                  while (game_self.game.deck.length < deckidx) {
                    game_self.addDeck();
                  }
                  game_self.old_discards = game_self.game.deck[deckidx - 1].discards;
                  game_self.old_removed = game_self.game.deck[deckidx - 1].removed;
                  game_self.old_cards = {};
                  game_self.old_crypt = [];
                  game_self.old_keys = [];
                  game_self.old_hand = [];
                  game_self.old_fhand = [];

                  // fhand -> faction hand - some games have 1 player controlling multiple "hands"
                  if (game_self.game.deck[deckidx - 1].fhand) {
                    game_self.old_fhand = game_self.game.deck[deckidx - 1].fhand;
                  }
                  for (_i1 = 0; _i1 < game_self.game.deck[deckidx - 1].crypt.length; _i1++) {
                    game_self.old_crypt[_i1] = game_self.game.deck[deckidx - 1].crypt[_i1];
                    game_self.old_keys[_i1] = game_self.game.deck[deckidx - 1].keys[_i1];
                  }
                  for (i in game_self.game.deck[deckidx - 1].cards) {
                    game_self.old_cards[i] = game_self.game.deck[deckidx - 1].cards[i];
                  }
                  for (_i10 = 0; _i10 < game_self.game.deck[deckidx - 1].hand.length; _i10++) {
                    game_self.old_hand[_i10] = game_self.game.deck[deckidx - 1].hand[_i10];
                  }
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context38.a(2, 1);
            }
          }, _callee38);
        }));
        return function (_x66, _x67) {
          return _ref33.apply(this, arguments);
        };
      }());

      /*
       * HANDBACKUP is like DECKBACKUP, except that it purges the undealt cards while
       * keeping the HAND and the DISCARDS and REMOVED cards information. This allows
       * removal of undealt cards, such as is handled in Twilight Struggle by the
       * dynamicDeckManagement() function.
       */
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'HANDBACKUP') {
          var deckidx = 1;
          if (gmv[1]) {
            deckidx = parseInt(gmv[1]);
          }
          while (game_self.game.deck.length < deckidx) {
            game_self.addDeck();
          }
          game_self.old_discards = game_self.game.deck[deckidx - 1].discards;
          game_self.old_removed = game_self.game.deck[deckidx - 1].removed;
          game_self.old_cards = {};
          game_self.old_crypt = [];
          game_self.old_keys = [];
          game_self.old_hand = [];

          // fhand -> faction hand - some games have 1 player controlling multiple "hands"
          if (game_self.game.deck[deckidx - 1].fhand) {
            game_self.old_fhand = game_self.game.deck[deckidx - 1].fhand;
          }
          for (var i = 0; i < game_self.game.deck[deckidx - 1].hand.length; i++) {
            game_self.old_hand[i] = game_self.game.deck[deckidx - 1].hand[i];
          }
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
        }
        return 1;
      });

      /*
            There are two ways to restore, which usually doesn't matter as the next
            instruction is almost always a shuffle, but we can restore the deck before/after
            the (added deck cards) add "push" to put new cards on top of deck,
            otherwise defaults to bottom of deck
      */
      this.commands.push(/*#__PURE__*/function () {
        var _ref34 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee39(game_self, gmv) {
          var deckidx, i, _i11, _i12, _i13, _i14, _i15, b;
          return _regenerator().w(function (_context39) {
            while (1) switch (_context39.n) {
              case 0:
                if (gmv[0] === 'DECKRESTORE') {
                  deckidx = 1;
                  if (gmv[1]) {
                    deckidx = parseInt(gmv[1]);
                  }
                  while (game_self.game.deck.length < deckidx) {
                    game_self.addDeck();
                  }
                  if (!game_self.game.deck[deckidx - 1].fhand) {
                    game_self.game.deck[deckidx - 1].fhand = [];
                  }
                  if (!game_self.game.deck[deckidx - 1].hand) {
                    game_self.game.deck[deckidx - 1].hand = [];
                  }
                  if (!game_self.game.deck[deckidx - 1].crypt) {
                    game_self.game.deck[deckidx - 1].crypt = [];
                  }
                  if (!game_self.game.deck[deckidx - 1].keys) {
                    game_self.game.deck[deckidx - 1].keys = [];
                  }
                  if (!game_self.game.deck[deckidx - 1].cards) {
                    game_self.game.deck[deckidx - 1].cards = {};
                  }
                  if (gmv[2] == 'push') {
                    if (game_self.old_fhand) {
                      for (i = 0; i < game_self.old_fhand.length; i++) {
                        if (i == 0) {
                          game_self.game.deck[deckidx - 1].fhand = [];
                        }
                        game_self.game.deck[deckidx - 1].fhand.push(game_self.old_fhand[i]);
                      }
                    }
                    for (_i11 = 0; _i11 < game_self.old_hand.length; _i11++) {
                      game_self.game.deck[deckidx - 1].hand.push(game_self.old_hand[_i11]);
                    }
                    for (_i12 = 0; _i12 < game_self.old_crypt.length; _i12++) {
                      game_self.game.deck[deckidx - 1].crypt.push(game_self.old_crypt[_i12]);
                      game_self.game.deck[deckidx - 1].keys.push(game_self.old_keys[_i12]);
                    }
                  } else {
                    if (game_self.old_fhand) {
                      for (_i13 = game_self.old_fhand.length - 1; _i13 >= 0; _i13--) {
                        if (_i13 == game_self.old_fhand.length - 1) {
                          game_self.game.deck[deckidx - 1].fhand = [];
                        }
                        game_self.game.deck[deckidx - 1].fhand.unshift(game_self.old_fhand[_i13]);
                      }
                    }
                    for (_i14 = game_self.old_hand.length - 1; _i14 >= 0; _i14--) {
                      game_self.game.deck[deckidx - 1].hand.unshift(game_self.old_hand[_i14]);
                    }
                    for (_i15 = game_self.old_crypt.length - 1; _i15 >= 0; _i15--) {
                      game_self.game.deck[deckidx - 1].crypt.unshift(game_self.old_crypt[_i15]);
                      game_self.game.deck[deckidx - 1].keys.unshift(game_self.old_keys[_i15]);
                    }
                  }
                  for (b in game_self.old_cards) {
                    game_self.game.deck[deckidx - 1].cards[b] = game_self.old_cards[b];
                  }
                  game_self.game.deck[deckidx - 1].removed = game_self.old_removed;
                  game_self.game.deck[deckidx - 1].discards = game_self.old_discards;
                  game_self.old_removed = {};
                  game_self.old_discards = {};
                  game_self.old_cards = {};
                  game_self.old_crypt = [];
                  game_self.old_keys = [];
                  game_self.old_hand = [];
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
              case 1:
                return _context39.a(2);
            }
          }, _callee39);
        }));
        return function (_x68, _x69) {
          return _ref34.apply(this, arguments);
        };
      }());

      //
      // cards added here are moved into the deck but not XORRED or added to the
      // crypt in a way that makes them dealable. This is useful if you want to
      // have cards in the .cards that are not dealt, such as if the cards have
      // already been dealt.
      //
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'DECKADDCARDS') {
          var deckidx = 1;
          var cards = {};
          if (gmv[1]) {
            deckidx = parseInt(gmv[1]);
          }
          if (gmv[2]) {
            cards = JSON.parse(gmv[2]);
          }
          while (game_self.game.deck.length < deckidx) {
            game_self.addDeck();
          }
          for (var key in cards) {
            if (!game_self.game.deck[0].cards[key]) {
              game_self.game.deck[0].cards[key] = cards[key];
            }
          }
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
        }
        return 1;
      });

      /*
        Given index of deck and length of crypt array
        Reads gmv[2] cards from game.queue and inserts them into deck[].crypt
      */
      this.commands.push(/*#__PURE__*/function () {
        var _ref35 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee40(game_self, gmv) {
          var deckidx, cryptLength, i, card;
          return _regenerator().w(function (_context40) {
            while (1) switch (_context40.n) {
              case 0:
                if (gmv[0] === 'CARDS') {
                  deckidx = parseInt(gmv[1]);
                  cryptLength = parseInt(gmv[2]);
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  for (i = 1; i <= cryptLength; i++) {
                    //Adding one to i here so don't have to insert additional -1 term
                    card = game_self.game.queue.pop();
                    if (game_self.game.player != 0) {
                      game_self.game.deck[deckidx - 1].crypt[cryptLength - i] = card;
                    }
                  }
                }
                return _context40.a(2, 1);
            }
          }, _callee40);
        }));
        return function (_x70, _x71) {
          return _ref35.apply(this, arguments);
        };
      }());

      /*
              Creates the pool data structure
          */
      this.commands.push(/*#__PURE__*/function () {
        var _ref36 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee41(game_self, gmv) {
          var poolidx;
          return _regenerator().w(function (_context41) {
            while (1) switch (_context41.n) {
              case 0:
                if (gmv[0] === 'POOL') {
                  poolidx = gmv[1];
                  while (game_self.game.pool.length < poolidx) {
                    game_self.addPool();
                  }
                  game_self.resetPool(poolidx - 1);
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context41.a(2, 1);
            }
          }, _callee41);
        }));
        return function (_x72, _x73) {
          return _ref36.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref37 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee42(game_self, gmv) {
          var deckidx, cards_to_flip, poolidx, cards_in_deck;
          return _regenerator().w(function (_context42) {
            while (1) switch (_context42.n) {
              case 0:
                if (gmv[0] === 'SAFEPOOLDEAL') {
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  deckidx = parseInt(gmv[1]);
                  cards_to_flip = parseInt(gmv[2]);
                  poolidx = parseInt(gmv[3]);
                  game_self.game.issued_keys_deleted = 0;
                  if (cards_to_flip <= game_self.game.deck[deckidx - 1].crypt.length) {
                    game_self.game.queue.push("POOLDEAL\t".concat(gmv[1], "\t").concat(gmv[2], "\t").concat(gmv[3]));
                  } else {
                    cards_in_deck = game_self.game.deck[deckidx - 1].crypt.length;
                    game_self.game.queue.push("POOLDEAL\t".concat(gmv[1], "\t").concat(cards_to_flip - cards_in_deck, "\t").concat(gmv[3]));
                    game_self.game.queue.push("SHUFFLEDISCARDS\t".concat(deckidx));
                    game_self.game.queue.push("POOLDEAL\t".concat(gmv[1], "\t").concat(cards_in_deck, "\t").concat(gmv[3]));
                  }
                }
                return _context42.a(2, 1);
            }
          }, _callee42);
        }));
        return function (_x74, _x75) {
          return _ref37.apply(this, arguments);
        };
      }());
      /**
       * A command of convenience for the flop in poker
       */
      this.commands.push(/*#__PURE__*/function () {
        var _ref38 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee43(game_self, gmv) {
          var deckidx, cards_to_flip, poolidx, i;
          return _regenerator().w(function (_context43) {
            while (1) switch (_context43.n) {
              case 0:
                if (gmv[0] === 'POOLDEAL') {
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  deckidx = parseInt(gmv[1]);
                  cards_to_flip = parseInt(gmv[2]);
                  poolidx = parseInt(gmv[3]);
                  game_self.game.issued_keys_deleted = 0;
                  for (i = 1; i <= _this.game.players.length; i++) {
                    _this.game.queue.push("FLIPCARD\t".concat(deckidx, "\t").concat(cards_to_flip, "\t").concat(poolidx, "\t").concat(i));
                  }

                  //Reset the pool
                  _this.game.queue.push('FLIPRESET\t' + poolidx);
                }
                return _context43.a(2, 1);
            }
          }, _callee43);
        }));
        return function (_x76, _x77) {
          return _ref38.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref39 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee44(game_self, gmv) {
          var poolidx;
          return _regenerator().w(function (_context44) {
            while (1) switch (_context44.n) {
              case 0:
                if (gmv[0] === 'FLIPRESET') {
                  poolidx = gmv[1];
                  while (game_self.game.pool.length < poolidx) {
                    game_self.addPool();
                  }
                  //Doesn't reset game_self.game.pool[poolidx-1].cards {} or .hand []
                  game_self.game.pool[poolidx - 1].crypt = [];
                  game_self.game.pool[poolidx - 1].keys = [];
                  game_self.game.pool[poolidx - 1].decrypted = 0;
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context44.a(2, 1);
            }
          }, _callee44);
        }));
        return function (_x78, _x79) {
          return _ref39.apply(this, arguments);
        };
      }());

      /*
      Deals cards from the deck to the pool (a common "hand" all players can see)
      */
      this.commands.push(/*#__PURE__*/function () {
        var _ref40 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee45(game_self, gmv) {
          var deckidx, cardnum, poolidx, playerid, _game_self$game3, alt_deck, i, _i16;
          return _regenerator().w(function (_context45) {
            while (1) switch (_context45.n) {
              case 0:
                if (!(gmv[0] === 'FLIPCARD')) {
                  _context45.n = 3;
                  break;
                }
                deckidx = gmv[1];
                cardnum = gmv[2];
                poolidx = gmv[3];
                playerid = parseInt(gmv[4]); //who is sending the keys
                //
                // players process 1 by 1
                //
                if (!(playerid != game_self.game.player)) {
                  _context45.n = 2;
                  break;
                }
                if (!((_game_self$game3 = game_self.game) !== null && _game_self$game3 !== void 0 && _game_self$game3.opponent_decks && game_self.game.opponent_decks[gmv[4]])) {
                  _context45.n = 1;
                  break;
                }
                game_self.game.queue.push('RESOLVE');
                alt_deck = game_self.game.opponent_decks[gmv[4]];
                cardnum = Math.min(cardnum, alt_deck[deckidx - 1].crypt.length);
                for (i = 0; i < cardnum; i++) {
                  game_self.game.queue.push(alt_deck[deckidx - 1].keys[i]);
                }
                game_self.game.queue.push("RESOLVEFLIP\t".concat(deckidx, "\t").concat(cardnum, "\t").concat(poolidx));
                alt_deck[deckidx - 1].keys.splice(0, cardnum);
                alt_deck[deckidx - 1].crypt.splice(0, cardnum);
                return _context45.a(2, 1);
              case 1:
                return _context45.a(2, 0);
              case 2:
                //
                // create pool if not exists
                //
                while (game_self.game.pool.length < poolidx) {
                  game_self.addPool();
                }

                //
                // share card decryption information
                //
                game_self.game.turn = [];
                game_self.game.turn.push('RESOLVE');
                cardnum = Math.min(cardnum, game_self.game.deck[deckidx - 1].crypt.length);
                //Deals from bottom of deck ??
                for (_i16 = 0; _i16 < cardnum; _i16++) {
                  game_self.game.turn.push(game_self.game.deck[deckidx - 1].keys[_i16]);
                }
                game_self.game.turn.push("RESOLVEFLIP\t".concat(deckidx, "\t").concat(cardnum, "\t").concat(poolidx));
                game_self.sendGameMoveTransaction('game', {});
                return _context45.a(2, 0);
              case 3:
                return _context45.a(2, 1);
            }
          }, _callee45);
        }));
        return function (_x80, _x81) {
          return _ref40.apply(this, arguments);
        };
      }());

      /*
      Preceeds (cardnum) keys on the queue for decrypting cards to store into each players pool
      */
      this.commands.push(/*#__PURE__*/function () {
        var _ref41 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee46(game_self, gmv) {
          var deckidx, cardnum, poolidx, decryption_keys_needed, z, keyidx, i, nc, thiskey, _i17, newcard;
          return _regenerator().w(function (_context46) {
            while (1) switch (_context46.n) {
              case 0:
                if (gmv[0] === 'RESOLVEFLIP') {
                  deckidx = parseInt(gmv[1]);
                  cardnum = parseInt(gmv[2]);
                  poolidx = parseInt(gmv[3]); //
                  // create pool if not exists, possible edge-case
                  //
                  while (game_self.game.pool.length < poolidx) {
                    game_self.addPool();
                  }

                  //
                  // how many players are going to send us decryption keys?
                  //
                  decryption_keys_needed = game_self.game.players.length; //
                  // if this is the first flip, we add the card to the crypt deck
                  // so that we can decrypt them as the keys come in.
                  //
                  if (game_self.game.pool[poolidx - 1].crypt.length == 0) {
                    //
                    // update cards available to pool (master description of the deck)
                    game_self.game.pool[poolidx - 1].cards = game_self.game.deck[deckidx - 1].cards;

                    //
                    // copy the card info over from the deck
                    //
                    for (z = 0; z < cardnum; z++) {
                      game_self.game.pool[poolidx - 1].crypt.push(game_self.game.deck[deckidx - 1].crypt[z]);
                    }
                    //for (let p = 0; p < decryption_keys_needed; p++) {
                    //  game_self.game.pool[poolidx - 1].keys.push([]);
                    //}
                  }

                  //
                  // now we can get the keys
                  //
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1); //Remove "ISSUEKEYS"
                  keyidx = game_self.game.queue.length - cardnum;
                  for (i = 0; i < cardnum; i++) {
                    nc = game_self.game.pool[poolidx - 1].crypt[i];
                    thiskey = game_self.game.queue[keyidx + i]; // add the key -- do we need to save it ?
                    //game_self.game.pool[poolidx - 1].keys[i] = thiskey;
                    if (thiskey != null) {
                      nc = game_self.app.crypto.decodeXOR(nc, thiskey);
                    }

                    // store card in pool
                    game_self.game.pool[poolidx - 1].crypt[i] = nc;
                  }
                  // processed one set of keys
                  game_self.game.pool[poolidx - 1].decrypted++;
                  if (cardnum > 0) {
                    game_self.game.queue.splice(keyidx, cardnum);
                  }

                  //
                  // if everything is handled, purge old deck data
                  //
                  if (game_self.game.pool[poolidx - 1].decrypted == decryption_keys_needed) {
                    for (_i17 = 0; _i17 < cardnum; _i17++) {
                      newcard = game_self.game.pool[poolidx - 1].crypt[_i17];
                      newcard = game_self.app.crypto.hexToString(newcard);
                      if (!game_self.game.pool[poolidx - 1].hand.includes(newcard)) {
                        game_self.game.pool[poolidx - 1].hand.push(newcard);
                      }
                      if (!game_self.game.pool[poolidx - 1].cards[newcard]) {
                        console.warn('GT [RESOLVEFLIP] Card decryption error!', 'Card: ' + newcard, 'pool:', JSON.parse(JSON.stringify(game_self.game.pool[poolidx - 1])));
                        if (game_self.app.BROWSER) {
                          siteMessage('There was a decryption error which will make the game unplayable');
                        }
                      }
                    }
                    game_self.game.pool[poolidx - 1].crypt.splice(0, cardnum);
                    game_self.game.deck[deckidx - 1].keys.splice(0, cardnum);
                    game_self.game.deck[deckidx - 1].crypt.splice(0, cardnum);
                  }
                }
                return _context46.a(2, 1);
            }
          }, _callee46);
        }));
        return function (_x82, _x83) {
          return _ref41.apply(this, arguments);
        };
      }());

      //
      // OBSERVER_CHECKPOINT - observers stop execution
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref42 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee47(game_self, gmv) {
          var _game_self$observerCo;
          return _regenerator().w(function (_context47) {
            while (1) switch (_context47.n) {
              case 0:
                if (!(gmv[0] === 'OBSERVER_CHECKPOINT')) {
                  _context47.n = 2;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                if (!(game_self.game.player == 0)) {
                  _context47.n = 1;
                  break;
                }
                //console.info('GT: Halt game for observer checkpoint');
                game_self.halted = 1;
                game_self.saveGame(game_self.game.id);
                (_game_self$observerCo = game_self.observerControls) === null || _game_self$observerCo === void 0 || _game_self$observerCo.updateStatus('Pause for Observer Checkpoint');
                return _context47.a(2, 0);
              case 1:
                return _context47.a(2, 1);
              case 2:
                return _context47.a(2, 1);
            }
          }, _callee47);
        }));
        return function (_x84, _x85) {
          return _ref42.apply(this, arguments);
        };
      }());

      /*
       * A command of convience to create and process a deck
       */
      this.commands.push(/*#__PURE__*/function () {
        var _ref43 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee48(game_self, gmv) {
          var deckidx, players, i, _i18;
          return _regenerator().w(function (_context48) {
            while (1) switch (_context48.n) {
              case 0:
                if (gmv[0] === 'DECKANDENCRYPT') {
                  deckidx = parseInt(gmv[1]);
                  players = parseInt(gmv[2]);
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                  for (i = players; i > 0; i--) {
                    _this.game.queue.push('DECKENCRYPT\t' + deckidx + '\t' + i);
                  }
                  for (_i18 = players; _i18 > 0; _i18--) {
                    _this.game.queue.push('DECKXOR\t' + deckidx + '\t' + _i18);
                  }
                  _this.game.queue.push('DECK\t' + deckidx + '\t' + gmv[3]);
                }
                return _context48.a(2, 1);
            }
          }, _callee48);
        }));
        return function (_x86, _x87) {
          return _ref43.apply(this, arguments);
        };
      }());

      /*
        Creates a deck + it's cryptographic version
      */
      this.commands.push(/*#__PURE__*/function () {
        var _ref44 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee49(game_self, gmv) {
          var deckidx, cards, c, _c, i;
          return _regenerator().w(function (_context49) {
            while (1) switch (_context49.n) {
              case 0:
                if (gmv[0] === 'DECK') {
                  deckidx = parseInt(gmv[1]);
                  cards = JSON.parse(gmv[2]); //
                  // create deck if not exists
                  //
                  while (game_self.game.deck.length < deckidx) {
                    game_self.addDeck();
                  }
                  game_self.resetDeck(deckidx - 1);

                  //
                  // AND and REMOVE cards....
                  //
                  // cards queue to be added are dynamically inserted into the DECK this way
                  // this permits adding a [] blank associative array. if also requires the
                  // card to exist on the deck prior, but will ensure that we encrypt the
                  // new card properly.
                  //
                  if (game_self.game.deck[deckidx - 1].to_add) {
                    for (c in game_self.game.deck[deckidx - 1].to_add) {
                      if (!game_self.game.deck[deckidx - 1].to_remove[c]) {
                        cards[c] = game_self.game.deck[deckidx - 1].cards[c];
                      } else {
                        delete game_self.game.deck[deckidx - 1].to_remove[c];
                        cards[c] = game_self.game.deck[deckidx - 1].cards[c];
                      }
                    }
                  }
                  game_self.game.deck[deckidx - 1].to_add = {};
                  //
                  // cards queue to be removed are dynamically removed from the DECK if
                  // submitted this way....
                  //
                  if (game_self.game.deck[deckidx - 1].to_remove) {
                    for (_c in game_self.game.deck[deckidx - 1].to_remove) {
                      if (cards[_c]) {
                        delete cards[_c];
                      }
                    }
                  }
                  game_self.game.deck[deckidx - 1].cards = cards;
                  for (i in game_self.game.deck[deckidx - 1].cards) {
                    game_self.game.deck[deckidx - 1].crypt.push(game_self.app.crypto.stringToHex(i));
                  }
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
                return _context49.a(2, 1);
            }
          }, _callee49);
        }));
        return function (_x88, _x89) {
          return _ref44.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref45 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee50(game_self, gmv) {
          var deckidx, playerid, r, i, _i19, extra;
          return _regenerator().w(function (_context50) {
            while (1) switch (_context50.n) {
              case 0:
                if (!(gmv[0] === 'DECKXOR')) {
                  _context50.n = 3;
                  break;
                }
                deckidx = parseInt(gmv[1]);
                playerid = parseInt(gmv[2]); //
                // ignore in async_dealing, as cards are stored in crypt in plaintext
                //
                if (!(game_self.async_dealing == 1)) {
                  _context50.n = 1;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context50.a(2, 1);
              case 1:
                if (!(playerid != game_self.game.player)) {
                  _context50.n = 2;
                  break;
                }
                return _context50.a(2, 0);
              case 2:
                if (game_self.game.deck[deckidx - 1].xor === '') {
                  r = Math.random();
                  game_self.game.deck[deckidx - 1].xor = game_self.app.crypto.hash("".concat(r));
                }
                console.log('DECKXOR set xor @ ' + (deckidx - 1) + ' encoding with: ' + game_self.game.deck[deckidx - 1].xor);
                for (i = 0; i < game_self.game.deck[deckidx - 1].crypt.length; i++) {
                  game_self.game.deck[deckidx - 1].crypt[i] = game_self.app.crypto.encodeXOR(game_self.game.deck[deckidx - 1].crypt[i], game_self.game.deck[deckidx - 1].xor);
                  game_self.game.deck[deckidx - 1].keys[i] = game_self.app.crypto.generateKeys();
                }

                //
                // shuffle the encrypted deck
                //
                game_self.game.deck[deckidx - 1].crypt = game_self.shuffleArray(game_self.game.deck[deckidx - 1].crypt);
                game_self.game.turn = [];
                game_self.game.turn.push('RESOLVE');
                for (_i19 = 0; _i19 < game_self.game.deck[deckidx - 1].crypt.length; _i19++) {
                  game_self.game.turn.push(game_self.game.deck[deckidx - 1].crypt[_i19]);
                }
                game_self.game.turn.push("CARDS\t".concat(deckidx, "\t").concat(game_self.game.deck[deckidx - 1].crypt.length));
                extra = {};
                game_self.sendGameMoveTransaction('game', extra);

                //
                // stop execution until messages received
                //
                return _context50.a(2, 0);
              case 3:
                return _context50.a(2, 1);
            }
          }, _callee50);
        }));
        return function (_x90, _x91) {
          return _ref45.apply(this, arguments);
        };
      }());

      //
      // required by safedeal
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref46 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee51(game_self, gmv) {
          var deckidx;
          return _regenerator().w(function (_context51) {
            while (1) switch (_context51.n) {
              case 0:
                if (gmv[0] === 'DECKFLUSH') {
                  deckidx = parseInt(gmv[1]);
                  if (gmv[2] == 'discards') {
                    _this.game.deck[deckidx].discards = {};
                  }
                  _this.game.queue.splice(qe, 1);
                }
                return _context51.a(2, 1);
            }
          }, _callee51);
        }));
        return function (_x92, _x93) {
          return _ref46.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref47 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee52(game_self, gmv) {
          var deckidx, playerid, i, _i20, extra;
          return _regenerator().w(function (_context52) {
            while (1) switch (_context52.n) {
              case 0:
                if (!(gmv[0] === 'DECKENCRYPT')) {
                  _context52.n = 3;
                  break;
                }
                deckidx = parseInt(gmv[1]);
                playerid = parseInt(gmv[2]);
                if (!(game_self.async_dealing == 1)) {
                  _context52.n = 1;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context52.a(2, 1);
              case 1:
                if (!(playerid != game_self.game.player)) {
                  _context52.n = 2;
                  break;
                }
                return _context52.a(2, 0);
              case 2:
                for (i = 0; i < game_self.game.deck[deckidx - 1].crypt.length; i++) {
                  game_self.game.deck[deckidx - 1].crypt[i] = game_self.app.crypto.decodeXOR(game_self.game.deck[deckidx - 1].crypt[i], game_self.game.deck[deckidx - 1].xor);
                  game_self.game.deck[deckidx - 1].crypt[i] = game_self.app.crypto.encodeXOR(game_self.game.deck[deckidx - 1].crypt[i], game_self.game.deck[deckidx - 1].keys[i]);
                }
                game_self.game.turn = [];
                game_self.game.turn.push('RESOLVE');
                for (_i20 = 0; _i20 < game_self.game.deck[deckidx - 1].crypt.length; _i20++) {
                  game_self.game.turn.push(game_self.game.deck[deckidx - 1].crypt[_i20]);
                }
                game_self.game.turn.push("CARDS\t".concat(deckidx, "\t").concat(game_self.game.deck[deckidx - 1].crypt.length));
                extra = {};
                game_self.sendGameMoveTransaction('game', extra);
                return _context52.a(2, 0);
              case 3:
                return _context52.a(2, 1);
            }
          }, _callee52);
        }));
        return function (_x94, _x95) {
          return _ref47.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref48 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee53(game_self, gmv) {
          return _regenerator().w(function (_context53) {
            while (1) switch (_context53.n) {
              case 0:
                if (gmv[0] === null || gmv[0] == 'null') {
                  game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                }
              case 1:
                return _context53.a(2);
            }
          }, _callee53);
        }));
        return function (_x96, _x97) {
          return _ref48.apply(this, arguments);
        };
      }());

      /////////////////
      // web3 crypto //
      /////////////////
      // supporting arbitrary third-party crypto modules -- specify receiving address
      // supporting arbitrary third-party crypto modules -- specify receiving address
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref49 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee54(game_self, gmv) {
          var playerkey, cryptokey, confsig, i;
          return _regenerator().w(function (_context54) {
            while (1) switch (_context54.n) {
              case 0:
                if (!(gmv[0] === 'CRYPTOKEY')) {
                  _context54.n = 1;
                  break;
                }
                playerkey = gmv[1];
                cryptokey = gmv[2];
                confsig = gmv[3]; //
                // if the playerkey has signed this cryptokey, update
                //
                if (game_self.app.crypto.verifyMessage(cryptokey, confsig, playerkey)) {
                  for (i = 0; i < game_self.game.keys.length; i++) {
                    if (game_self.game.players[i] === playerkey) {
                      game_self.game.keys[i] = cryptokey;
                    }
                  }
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context54.a(2, 1);
              case 1:
                return _context54.a(2, 1);
            }
          }, _callee54);
        }));
        return function (_x98, _x99) {
          return _ref49.apply(this, arguments);
        };
      }());

      //
      // share my game-available cryptos + balances
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref50 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee55(game_self, gmv) {
          var playerkey, cryptos;
          return _regenerator().w(function (_context55) {
            while (1) switch (_context55.n) {
              case 0:
                if (!(gmv[0] === 'AVAILABLE_CRYPTOS')) {
                  _context55.n = 1;
                  break;
                }
                playerkey = gmv[1];
                cryptos = JSON.parse(gmv[2]);
                if (!_this.game.cryptos) {
                  _this.game.cryptos = {};
                }

                // Need to fix this... indexing on player number is bad for dynamic games...

                _this.game.cryptos[playerkey] = cryptos;
                playerkey = parseInt(playerkey);

                // Don't need to save my own...
                if (_this.game.player !== playerkey) {
                  _this.app.wallet.saveAvailableCryptosAssociativeArray(_this.game.players[playerkey - 1], cryptos);
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context55.a(2, 1);
              case 1:
                return _context55.a(2, 1);
            }
          }, _callee55);
        }));
        return function (_x100, _x101) {
          return _ref50.apply(this, arguments);
        };
      }());

      //
      //
      // players can share game-available cryptos + balances
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref51 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee56(game_self, gmv) {
          var playerkey, ac;
          return _regenerator().w(function (_context56) {
            while (1) switch (_context56.n) {
              case 0:
                if (!(gmv[0] === 'REQUEST_AVAILABLE_CRYPTOS')) {
                  _context56.n = 3;
                  break;
                }
                playerkey = parseInt(gmv[1]);
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                if (!(game_self.game.player == playerkey)) {
                  _context56.n = 2;
                  break;
                }
                _context56.n = 1;
                return game_self.app.wallet.returnAvailableCryptosAssociativeArray();
              case 1:
                ac = _context56.v;
                game_self.addMove("AVAILABLE_CRYPTOS\t".concat(playerkey, "\t").concat(JSON.stringify(ac)));
                game_self.game.turn = game_self.moves;
                game_self.moves = [];
                game_self.sendGameMoveTransaction('game', {});
              case 2:
                return _context56.a(2, 0);
              case 3:
                return _context56.a(2, 1);
            }
          }, _callee56);
        }));
        return function (_x102, _x103) {
          return _ref51.apply(this, arguments);
        };
      }());

      //
      // NFTs are handled in the same way
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref52 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee57(game_self, gmv) {
          var playerkey, nfts;
          return _regenerator().w(function (_context57) {
            while (1) switch (_context57.n) {
              case 0:
                if (!(gmv[0] === 'AVAILABLE_NFTS')) {
                  _context57.n = 1;
                  break;
                }
                playerkey = gmv[1];
                nfts = JSON.parse(gmv[2]);
                if (!_this.game.cryptos) {
                  _this.game.nfts = {};
                }
                _this.game.nfts[playerkey] = nfts;
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context57.a(2, 1);
              case 1:
                return _context57.a(2, 1);
            }
          }, _callee57);
        }));
        return function (_x104, _x105) {
          return _ref52.apply(this, arguments);
        };
      }());

      //
      //
      // players can share game-available cryptos + balances
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref53 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee58(game_self, gmv) {
          var playerkey, an;
          return _regenerator().w(function (_context58) {
            while (1) switch (_context58.n) {
              case 0:
                if (!(gmv[0] === 'REQUEST_AVAILABLE_NFTS')) {
                  _context58.n = 1;
                  break;
                }
                playerkey = parseInt(gmv[1]);
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                if (game_self.game.player == playerkey) {
                  an = [];
                  game_self.addMove("AVAILABLE_NFTS\t".concat(playerkey, "\t").concat(JSON.stringify(an)));
                  game_self.game.turn = game_self.moves;
                  game_self.moves = [];
                  game_self.sendGameMoveTransaction('game', {});
                }
                return _context58.a(2, 0);
              case 1:
                return _context58.a(2, 1);
            }
          }, _callee58);
        }));
        return function (_x106, _x107) {
          return _ref53.apply(this, arguments);
        };
      }());

      //
      // supporting arbitrary third-party crypto modules
      //
      this.commands.push(/*#__PURE__*/function () {
        var _ref54 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee60(game_self, gmv) {
          var sender, receiver, amount, ts, unique_hash, ticker, this_self, sender_crypto_address, receiver_crypto_address, i, my_specific_game_id, my_queue_entry, sendPaymentWrapper;
          return _regenerator().w(function (_context60) {
            while (1) switch (_context60.n) {
              case 0:
                if (!(gmv[0] === 'SEND')) {
                  _context60.n = 2;
                  break;
                }
                sender = gmv[1];
                receiver = gmv[2];
                amount = gmv[3];
                ts = gmv[4];
                unique_hash = gmv[5];
                ticker = game_self.game.crypto;
                if (gmv[6]) {
                  ticker = gmv[6];
                }
                this_self = _this; //
                // if we are not the sender, we do not need to worry and can continue
                //
                // note: senders identified by Saito publickey not other in this function
                //
                if (!(game_self.publicKey !== sender)) {
                  _context60.n = 1;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context60.a(2, 1);
              case 1:
                //
                // if we are the sender, lets get sending and receiving addresses
                //
                sender_crypto_address = '';
                receiver_crypto_address = '';
                for (i = 0; i < game_self.game.players.length; i++) {
                  if (game_self.game.players[i] === sender) {
                    sender_crypto_address = game_self.game.keys[i];
                  }
                  if (game_self.game.players[i] === receiver) {
                    receiver_crypto_address = game_self.game.keys[i];
                  }
                }
                my_specific_game_id = game_self.game.id;
                my_queue_entry = game_self.game.queue[game_self.game.queue.length - 1];
                game_self.saveGame(game_self.game.id);
                game_self.halted = 1;
                sendPaymentWrapper = /*#__PURE__*/function () {
                  var _ref55 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee59() {
                    return _regenerator().w(function (_context59) {
                      while (1) switch (_context59.n) {
                        case 0:
                          _context59.n = 1;
                          return game_self.app.wallet.sendPayment(ticker, [sender_crypto_address], [receiver_crypto_address], [amount], unique_hash, function (robj) {
                            if (game_self.game.id != my_specific_game_id) {
                              game_self.game = game_self.loadGame(my_specific_game_id);
                            }
                            game_self.app.connection.emit('saito-crypto-send-confirm', robj);

                            //
                            // our SEND entry was at the tail when we halted, and the queue is
                            // frozen while we wait -- if the tail is no longer our entry, the
                            // queue changed underneath us (duplicate callback, or something
                            // else consumed it) and we must not splice a different command
                            //
                            if (game_self.game.queue[game_self.game.queue.length - 1] !== my_queue_entry) {
                              console.warn('GT [SEND] our entry is not at the end of the queue, ignoring callback');
                              return 0;
                            }
                            game_self.updateLog('payments issued...');
                            game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                            game_self.restartQueue();
                            return 0;
                          }, receiver, "".concat(game_self.name, " stake"));
                        case 1:
                          return _context59.a(2);
                      }
                    }, _callee59);
                  }));
                  return function sendPaymentWrapper() {
                    return _ref55.apply(this, arguments);
                  };
                }();
                game_self.app.connection.emit('saito-game-crypto-send-auth-open-request', {
                  publicKey: receiver,
                  address: receiver_crypto_address,
                  amount: amount,
                  ticker: ticker,
                  hash: unique_hash,
                  game_id: game_self.game.id,
                  trusted: game_self.game.terminating ? true : this_self.loadGamePreference('crypto_transfers_outbound_trusted'),
                  mycallback: sendPaymentWrapper
                });
                return _context60.a(2, 0);
              case 2:
                return _context60.a(2, 1);
            }
          }, _callee60);
        }));
        return function (_x108, _x109) {
          return _ref54.apply(this, arguments);
        };
      }());
      this.commands.push(/*#__PURE__*/function () {
        var _ref56 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee61(game_self, gmv) {
          var sender, receiver, amount, ts, unique_hash, ticker, this_self, sender_crypto_address, receiver_crypto_address, i, my_specific_game_id, my_queue_entry;
          return _regenerator().w(function (_context61) {
            while (1) switch (_context61.n) {
              case 0:
                if (!(gmv[0] === 'RECEIVE')) {
                  _context61.n = 3;
                  break;
                }
                sender = gmv[1];
                receiver = gmv[2];
                amount = gmv[3];
                ts = gmv[4];
                unique_hash = gmv[5];
                ticker = game_self.game.crypto;
                if (gmv[6]) {
                  ticker = gmv[6];
                }
                this_self = _this; //
                // if we are not the receiver, we do not need to worry and can continue
                //
                // note: senders identified by Saito publickey not other in this function
                //
                if (!(game_self.publicKey !== receiver)) {
                  _context61.n = 1;
                  break;
                }
                game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                return _context61.a(2, 1);
              case 1:
                //
                // if we are the sender, lets get sending and receiving addresses
                //
                sender_crypto_address = '';
                receiver_crypto_address = '';
                for (i = 0; i < game_self.game.players.length; i++) {
                  if (game_self.game.players[i] === sender) {
                    sender_crypto_address = game_self.game.keys[i];
                  }
                  if (game_self.game.players[i] === receiver) {
                    receiver_crypto_address = game_self.game.keys[i];
                  }
                }
                my_specific_game_id = game_self.game.id;
                my_queue_entry = game_self.game.queue[game_self.game.queue.length - 1];
                game_self.saveGame(game_self.game.id);
                game_self.halted = 1;

                //
                // Update 6/17/2026
                // We launch the overlay before calling receivePayment
                // because the continue code is triggered by closing the overlay, which
                // listens for a confirmation event emitted by the crypto, that could be instantaneous
                //
                game_self.app.connection.emit('saito-crypto-game-receive-render-request', {
                  address: sender_crypto_address,
                  publicKey: sender,
                  amount: amount,
                  ticker: ticker,
                  hash: unique_hash,
                  game_id: game_self.game.id,
                  mycallback: function mycallback() {
                    if (game_self.game.id != my_specific_game_id) {
                      game_self.game = game_self.loadGame(my_specific_game_id);
                    }

                    //
                    // our RECEIVE entry was at the tail when we halted, and the queue is
                    // frozen while we wait -- if the tail is no longer our entry, the
                    // queue changed underneath us (duplicate callback, or something
                    // else consumed it) and we must not splice a different command
                    //
                    if (game_self.game.queue[game_self.game.queue.length - 1] !== my_queue_entry) {
                      console.warn('GT [RECEIVE] our entry is not at the end of the queue, ignoring callback');
                      return 0;
                    }
                    game_self.updateLog('payments received...');
                    game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
                    game_self.restartQueue();
                    return 0;
                  }
                });
                _context61.n = 2;
                return game_self.app.wallet.receivePayment(ticker, sender_crypto_address, amount, unique_hash);
              case 2:
                return _context61.a(2, 0);
              case 3:
                return _context61.a(2, 1);
            }
          }, _callee61);
        }));
        return function (_x110, _x111) {
          return _ref56.apply(this, arguments);
        };
      }());
    }
  }]);
}();
module.exports = GameQueue;